//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';
import 'moment-duration-format';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class CiCdClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    createFirmware(deviceType: string | null | undefined, file: FileParameter | null | undefined, comment: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/factory/firmware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (deviceType !== null && deviceType !== undefined)
            content_.append("DeviceType", deviceType.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (comment !== null && comment !== undefined)
            content_.append("Comment", comment.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFirmware(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFirmware(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreateFirmware(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    getUserRoles(request: GetUserRolesQuery): Observable<UserRoleResponse[]> {
        let url_ = this.baseUrl + "/get-user-roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleResponse[]>;
        }));
    }

    protected processGetUserRoles(response: HttpResponseBase): Observable<UserRoleResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsers(request: GetUsersQuery): Observable<UserResponse[]> {
        let url_ = this.baseUrl + "/get-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserResponse[]>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUser(request: AddUserCommand): Observable<void> {
        let url_ = this.baseUrl + "/add-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUserRole(request: AddUserRoleCommand): Observable<void> {
        let url_ = this.baseUrl + "/add-user-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUserRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeUser(request: RemoveUserCommand): Observable<void> {
        let url_ = this.baseUrl + "/remove-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeUserRole(request: RemoveUserRoleCommand): Observable<void> {
        let url_ = this.baseUrl + "/remove-user-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(request: UpdateUserCommand): Observable<void> {
        let url_ = this.baseUrl + "/update-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserRole(request: UpdateUserRoleCommand): Observable<void> {
        let url_ = this.baseUrl + "/update-user-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TracksClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    calculateWalkParts(request: CalculateWalkParts): Observable<TrackPart[]> {
        let url_ = this.baseUrl + "/calculate-walk-parts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateWalkParts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateWalkParts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrackPart[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrackPart[]>;
        }));
    }

    protected processCalculateWalkParts(response: HttpResponseBase): Observable<TrackPart[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrackPart.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    debugWalkParts(request: DebugWalkParts): Observable<RelativeTrackPoint[]> {
        let url_ = this.baseUrl + "/debug-walk-parts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDebugWalkParts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDebugWalkParts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelativeTrackPoint[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelativeTrackPoint[]>;
        }));
    }

    protected processDebugWalkParts(response: HttpResponseBase): Observable<RelativeTrackPoint[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RelativeTrackPoint.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRejectedTracks(request: GetRejectedTracks): Observable<{ [key: string]: TrackPartial[]; }> {
        let url_ = this.baseUrl + "/get-rejected-tracks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRejectedTracks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRejectedTracks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: TrackPartial[]; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: TrackPartial[]; }>;
        }));
    }

    protected processGetRejectedTracks(response: HttpResponseBase): Observable<{ [key: string]: TrackPartial[]; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? resultData200[key].map((i: any) => TrackPartial.fromJS(i)) : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStraightParts(request: GetStraightParts): Observable<StraightPart[]> {
        let url_ = this.baseUrl + "/get-straight-parts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStraightParts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStraightParts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StraightPart[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StraightPart[]>;
        }));
    }

    protected processGetStraightParts(response: HttpResponseBase): Observable<StraightPart[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StraightPart.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTrack(request: GetTrack): Observable<Track> {
        let url_ = this.baseUrl + "/get-track";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Track>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Track>;
        }));
    }

    protected processGetTrack(response: HttpResponseBase): Observable<Track> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Track.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWalks(request: GetWalks): Observable<PagedListOfWalk> {
        let url_ = this.baseUrl + "/get-walks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWalks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWalks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfWalk>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfWalk>;
        }));
    }

    protected processGetWalks(response: HttpResponseBase): Observable<PagedListOfWalk> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfWalk.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recalculateWalk(request: RecalculateWalkCommand): Observable<void> {
        let url_ = this.baseUrl + "/recalculate-walk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecalculateWalk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecalculateWalk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecalculateWalk(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SubscriptionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    getInvoices(request: GetInvoices): Observable<SubscriptionInvoice[]> {
        let url_ = this.baseUrl + "/get-invoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionInvoice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionInvoice[]>;
        }));
    }

    protected processGetInvoices(response: HttpResponseBase): Observable<SubscriptionInvoice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionInvoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPromoCodes(request: GetPromoCodes): Observable<PromoCode[]> {
        let url_ = this.baseUrl + "/get-promo-codes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromoCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromoCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromoCode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromoCode[]>;
        }));
    }

    protected processGetPromoCodes(response: HttpResponseBase): Observable<PromoCode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromoCode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubscriptionPlans(request: GetSubscriptionPlans): Observable<SubscriptionPlan[]> {
        let url_ = this.baseUrl + "/get-subscription-plans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionPlans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionPlans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPlan[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPlan[]>;
        }));
    }

    protected processGetSubscriptionPlans(response: HttpResponseBase): Observable<SubscriptionPlan[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionPlan.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsertPromoCode(request: UpsertPromoCode): Observable<void> {
        let url_ = this.baseUrl + "/upsert-promo-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertPromoCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertPromoCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertPromoCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelSubscription(request: CancelSubscriptionCommand): Observable<void> {
        let url_ = this.baseUrl + "/cancel-subscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refundPayment(request: RefundPaymentCommand): Observable<void> {
        let url_ = this.baseUrl + "/refund-payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefundPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefundPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefundPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSubscriptionDescription(request: UpdateSubscriptionDescriptionCommand): Observable<void> {
        let url_ = this.baseUrl + "/update-subscription-description";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubscriptionDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscriptionDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSubscriptionDescription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    getRequestErrors(request: GetRequestErrors): Observable<RequestError[]> {
        let url_ = this.baseUrl + "/get-request-errors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestErrors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestErrors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestError[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestError[]>;
        }));
    }

    protected processGetRequestErrors(response: HttpResponseBase): Observable<RequestError[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RequestError.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRequests(request: GetRequests): Observable<PagedListOfRequestSnapshot> {
        let url_ = this.baseUrl + "/get-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfRequestSnapshot>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfRequestSnapshot>;
        }));
    }

    protected processGetRequests(response: HttpResponseBase): Observable<PagedListOfRequestSnapshot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfRequestSnapshot.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PetsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    getPetOwner(request: GetPetOwner): Observable<string> {
        let url_ = this.baseUrl + "/get-pet-owner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPetOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPetOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPetOwner(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FirmwaresClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    getFirmwares(request: GetFirmwaresQuery): Observable<FirmwareResponse[]> {
        let url_ = this.baseUrl + "/get-firmwares";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirmwares(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirmwares(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirmwareResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirmwareResponse[]>;
        }));
    }

    protected processGetFirmwares(response: HttpResponseBase): Observable<FirmwareResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FirmwareResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateFirmware(request: ActivateFirmware): Observable<void> {
        let url_ = this.baseUrl + "/activate-firmware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateFirmware(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateFirmware(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateFirmware(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addFirmware(revision: string | null | undefined, file: FileParameter | null | undefined, comment: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/add-firmware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (revision !== null && revision !== undefined)
            content_.append("Revision", revision.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (comment !== null && comment !== undefined)
            content_.append("Comment", comment.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFirmware(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFirmware(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddFirmware(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateFirmware(request: DeactivateFirmware): Observable<void> {
        let url_ = this.baseUrl + "/deactivate-firmware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateFirmware(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateFirmware(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateFirmware(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reviewFirmware(request: ReviewFirmwareCommand): Observable<void> {
        let url_ = this.baseUrl + "/review-firmware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReviewFirmware(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReviewFirmware(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReviewFirmware(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFirmware(request: UpdateFirmware): Observable<void> {
        let url_ = this.baseUrl + "/update-firmware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFirmware(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFirmware(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFirmware(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DictionariesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    getDictionaries(request: GetDictionariesQuery): Observable<DictionaryResponse> {
        let url_ = this.baseUrl + "/get-dictionaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDictionaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDictionaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryResponse>;
        }));
    }

    protected processGetDictionaries(response: HttpResponseBase): Observable<DictionaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DictionaryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DevicesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    getBatteries(request: GetBatteries): Observable<PagedListOfBattery> {
        let url_ = this.baseUrl + "/get-batteries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatteries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatteries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfBattery>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfBattery>;
        }));
    }

    protected processGetBatteries(response: HttpResponseBase): Observable<PagedListOfBattery> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfBattery.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBeacons(request: GetBeacons): Observable<PagedListOfBeacon> {
        let url_ = this.baseUrl + "/get-beacons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBeacons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeacons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfBeacon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfBeacon>;
        }));
    }

    protected processGetBeacons(response: HttpResponseBase): Observable<PagedListOfBeacon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfBeacon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCollarBattery(request: GetCollarBattery): Observable<DeviceBatteryInfoResponse> {
        let url_ = this.baseUrl + "/get-collar-battery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollarBattery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollarBattery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceBatteryInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceBatteryInfoResponse>;
        }));
    }

    protected processGetCollarBattery(response: HttpResponseBase): Observable<DeviceBatteryInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceBatteryInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCollarLocations(request: GetCollarLocations): Observable<CollarLocation[]> {
        let url_ = this.baseUrl + "/get-collar-locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollarLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollarLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollarLocation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollarLocation[]>;
        }));
    }

    protected processGetCollarLocations(response: HttpResponseBase): Observable<CollarLocation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CollarLocation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCollarRevisions(request: GetCollarRevisions): Observable<CollarRevision[]> {
        let url_ = this.baseUrl + "/get-collar-revisions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollarRevisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollarRevisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollarRevision[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollarRevision[]>;
        }));
    }

    protected processGetCollarRevisions(response: HttpResponseBase): Observable<CollarRevision[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CollarRevision.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCollars(request: GetCollars): Observable<PagedListOfCollar> {
        let url_ = this.baseUrl + "/get-collars";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfCollar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfCollar>;
        }));
    }

    protected processGetCollars(response: HttpResponseBase): Observable<PagedListOfCollar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfCollar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerBatteries(request: GetCustomerBatteries): Observable<Battery[]> {
        let url_ = this.baseUrl + "/get-customer-batteries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerBatteries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerBatteries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Battery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Battery[]>;
        }));
    }

    protected processGetCustomerBatteries(response: HttpResponseBase): Observable<Battery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Battery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFlashlights(request: GetFlashlights): Observable<PagedListOfFlashlight> {
        let url_ = this.baseUrl + "/get-flashlights";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlashlights(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlashlights(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfFlashlight>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfFlashlight>;
        }));
    }

    protected processGetFlashlights(response: HttpResponseBase): Observable<PagedListOfFlashlight> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfFlashlight.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJigs(request: GetJigs): Observable<Jig[]> {
        let url_ = this.baseUrl + "/get-jigs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Jig[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Jig[]>;
        }));
    }

    protected processGetJigs(response: HttpResponseBase): Observable<Jig[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Jig.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSimInfo(request: GetSimInfo): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/get-sim-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSimInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSimInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processGetSimInfo(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateSim(request: ActivateSim): Observable<void> {
        let url_ = this.baseUrl + "/activate-sim";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateSim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateSim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateSim(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addCollarRevision(request: AddCollarRevision): Observable<void> {
        let url_ = this.baseUrl + "/add-collar-revision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCollarRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCollarRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddCollarRevision(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeCollarServiceSettings(request: ChangeCollarServiceSettings): Observable<void> {
        let url_ = this.baseUrl + "/change-collar-service-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeCollarServiceSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeCollarServiceSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeCollarServiceSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateSim(request: DeactivateSim): Observable<void> {
        let url_ = this.baseUrl + "/deactivate-sim";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateSim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateSim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateSim(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCollarRevision(request: UpdateCollarRevision): Observable<void> {
        let url_ = this.baseUrl + "/update-collar-revision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCollarRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCollarRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCollarRevision(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadAnimations(file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/upload-animations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAnimations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAnimations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadAnimations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsertJig(request: UpsertJig): Observable<void> {
        let url_ = this.baseUrl + "/upsert-jig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertJig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertJig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertJig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    getFirmwareStats(request: GetFirmwareStats): Observable<FirmwareStat[]> {
        let url_ = this.baseUrl + "/get-firmware-stats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirmwareStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirmwareStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirmwareStat[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirmwareStat[]>;
        }));
    }

    protected processGetFirmwareStats(response: HttpResponseBase): Observable<FirmwareStat[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FirmwareStat.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    getCustomers(request: GetCustomers): Observable<PagedListOfCustomer> {
        let url_ = this.baseUrl + "/get-customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfCustomer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfCustomer>;
        }));
    }

    protected processGetCustomers(response: HttpResponseBase): Observable<PagedListOfCustomer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfCustomer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSessions(request: GetSessions): Observable<Session[]> {
        let url_ = this.baseUrl + "/get-sessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Session[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Session[]>;
        }));
    }

    protected processGetSessions(response: HttpResponseBase): Observable<Session[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Session.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BreedsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    getBreeds(request: GetBreeds): Observable<Breed[]> {
        let url_ = this.baseUrl + "/get-breeds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBreeds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBreeds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Breed[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Breed[]>;
        }));
    }

    protected processGetBreeds(response: HttpResponseBase): Observable<Breed[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Breed.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addBreed(request: AddBreed): Observable<string> {
        let url_ = this.baseUrl + "/add-breed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBreed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBreed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddBreed(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteBreed(request: DeleteBreed): Observable<void> {
        let url_ = this.baseUrl + "/delete-breed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBreed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBreed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBreed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateBreed(request: UpdateBreed): Observable<void> {
        let url_ = this.baseUrl + "/update-breed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBreed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBreed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBreed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthenticationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    getProfile(request: GetProfileQuery): Observable<ProfileResponse> {
        let url_ = this.baseUrl + "/get-profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileResponse>;
        }));
    }

    protected processGetProfile(response: HttpResponseBase): Observable<ProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    impersonate(request: Impersonate): Observable<string> {
        let url_ = this.baseUrl + "/impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    signIn(request: SignInCommand): Observable<void> {
        let url_ = this.baseUrl + "/sign-in";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSignIn(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    signOut(request: SignOutCommand): Observable<void> {
        let url_ = this.baseUrl + "/sign-out";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSignOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AchievementsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    getAchievementTypes(request: GetAchievementTypes): Observable<AchievementType[]> {
        let url_ = this.baseUrl + "/get-achievement-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAchievementTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAchievementTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AchievementType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AchievementType[]>;
        }));
    }

    protected processGetAchievementTypes(response: HttpResponseBase): Observable<AchievementType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AchievementType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmailConfirmationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44200";
    }

    emailConfirmation(request: EmailConfirmationCommand): Observable<void> {
        let url_ = this.baseUrl + "/email-confirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmailConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class UserRoleResponse implements IUserRoleResponse {
    id?: string;
    name?: string;
    scopes?: string[];

    constructor(data?: IUserRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
        }
    }

    static fromJS(data: any): UserRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        return data;
    }
}

export interface IUserRoleResponse {
    id?: string;
    name?: string;
    scopes?: string[];
}

export class GetUserRolesQuery implements IGetUserRolesQuery {

    constructor(data?: IGetUserRolesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetUserRolesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRolesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetUserRolesQuery {
}

export class UserPartialResponse implements IUserPartialResponse {
    id?: string;
    nickname?: string | undefined;

    constructor(data?: IUserPartialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nickname = _data["nickname"];
        }
    }

    static fromJS(data: any): UserPartialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserPartialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nickname"] = this.nickname;
        return data;
    }
}

export interface IUserPartialResponse {
    id?: string;
    nickname?: string | undefined;
}

export class UserResponse extends UserPartialResponse implements IUserResponse {
    username?: string;
    roles?: string[];

    constructor(data?: IUserResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static override fromJS(data: any): UserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUserResponse extends IUserPartialResponse {
    username?: string;
    roles?: string[];
}

export class GetUsersQuery implements IGetUsersQuery {

    constructor(data?: IGetUsersQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetUsersQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetUsersQuery {
}

export class TrackPart implements ITrackPart {
    level?: SpeedLevel;
    points?: TrackPoint[];

    constructor(data?: ITrackPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(TrackPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrackPart {
        data = typeof data === 'object' ? data : {};
        let result = new TrackPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrackPart {
    level?: SpeedLevel;
    points?: TrackPoint[];
}

/** 1 = OnFoot 2 = Car 4 = Plane 255 = Off */
export enum SpeedLevel {
    OnFoot = 1,
    Car = 2,
    Plane = 4,
    Off = 255,
}

export class TrackPoint implements ITrackPoint {
    timestamp?: moment.Moment;
    lng?: number;
    lat?: number;
    alt?: number;
    battery_charge?: number;
    accuracy?: number | undefined;
    mode?: DeviceMode | undefined;
    fixed_by?: CoordinateFixType | undefined;

    constructor(data?: ITrackPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.lng = _data["lng"];
            this.lat = _data["lat"];
            this.alt = _data["alt"];
            this.battery_charge = _data["battery_charge"];
            this.accuracy = _data["accuracy"];
            this.mode = _data["mode"];
            this.fixed_by = _data["fixed_by"];
        }
    }

    static fromJS(data: any): TrackPoint {
        data = typeof data === 'object' ? data : {};
        let result = new TrackPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["alt"] = this.alt;
        data["battery_charge"] = this.battery_charge;
        data["accuracy"] = this.accuracy;
        data["mode"] = this.mode;
        data["fixed_by"] = this.fixed_by;
        return data;
    }
}

export interface ITrackPoint {
    timestamp?: moment.Moment;
    lng?: number;
    lat?: number;
    alt?: number;
    battery_charge?: number;
    accuracy?: number | undefined;
    mode?: DeviceMode | undefined;
    fixed_by?: CoordinateFixType | undefined;
}

/** 0 = NotSet 1 = Sleep 2 = Safe 3 = Walk 4 = Alarm 5 = Lost 6 = Charging 7 = FwUpdate 8 = Begin 9 = Fsafe 10 = Fwalk 11 = Off 12 = NotSetDog 13 = NotActivated 14 = LowEnergy 15 = Ble 16 = FirstWu 17 = EnergySaving 18 = OffLeash 99 = Idle 100 = NotWalking */
export enum DeviceMode {
    NotSet = 0,
    Sleep = 1,
    Safe = 2,
    Walk = 3,
    Alarm = 4,
    Lost = 5,
    Charging = 6,
    FwUpdate = 7,
    Begin = 8,
    Fsafe = 9,
    Fwalk = 10,
    Off = 11,
    NotSetDog = 12,
    NotActivated = 13,
    LowEnergy = 14,
    Ble = 15,
    FirstWu = 16,
    EnergySaving = 17,
    OffLeash = 18,
    Idle = 99,
    NotWalking = 100,
}

/** 0 = None 1 = LowAccuracy 2 = Gps2D 3 = Gps3D 4 = Phone 5 = Gsm 6 = WiFi */
export enum CoordinateFixType {
    None = 0,
    LowAccuracy = 1,
    Gps2D = 2,
    Gps3D = 3,
    Phone = 4,
    Gsm = 5,
    WiFi = 6,
}

export class CalculateWalkParts implements ICalculateWalkParts {
    id?: string;
    accuracy_percentile?: number | undefined;
    foot_kalman_decay?: number | undefined;
    car_kalman_decay?: number | undefined;
    bunch_area?: number | undefined;
    douglas_tolerance?: number | undefined;
    curve_level?: number | undefined;
    curve_strength?: number | undefined;
    ema_alpha?: number | undefined;
    ema_window?: number | undefined;

    constructor(data?: ICalculateWalkParts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accuracy_percentile = _data["accuracy_percentile"];
            this.foot_kalman_decay = _data["foot_kalman_decay"];
            this.car_kalman_decay = _data["car_kalman_decay"];
            this.bunch_area = _data["bunch_area"];
            this.douglas_tolerance = _data["douglas_tolerance"];
            this.curve_level = _data["curve_level"];
            this.curve_strength = _data["curve_strength"];
            this.ema_alpha = _data["ema_alpha"];
            this.ema_window = _data["ema_window"];
        }
    }

    static fromJS(data: any): CalculateWalkParts {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateWalkParts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accuracy_percentile"] = this.accuracy_percentile;
        data["foot_kalman_decay"] = this.foot_kalman_decay;
        data["car_kalman_decay"] = this.car_kalman_decay;
        data["bunch_area"] = this.bunch_area;
        data["douglas_tolerance"] = this.douglas_tolerance;
        data["curve_level"] = this.curve_level;
        data["curve_strength"] = this.curve_strength;
        data["ema_alpha"] = this.ema_alpha;
        data["ema_window"] = this.ema_window;
        return data;
    }
}

export interface ICalculateWalkParts {
    id?: string;
    accuracy_percentile?: number | undefined;
    foot_kalman_decay?: number | undefined;
    car_kalman_decay?: number | undefined;
    bunch_area?: number | undefined;
    douglas_tolerance?: number | undefined;
    curve_level?: number | undefined;
    curve_strength?: number | undefined;
    ema_alpha?: number | undefined;
    ema_window?: number | undefined;
}

export class TrackPoint2 implements ITrackPoint2 {
    timestamp?: moment.Moment;
    location?: Point;
    accuracy?: number;
    device_mode?: DeviceMode;
    battery_charge?: number;
    fixed_by?: CoordinateFixType;

    constructor(data?: ITrackPoint2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.location = _data["location"] ? Point.fromJS(_data["location"]) : <any>undefined;
            this.accuracy = _data["accuracy"];
            this.device_mode = _data["device_mode"];
            this.battery_charge = _data["battery_charge"];
            this.fixed_by = _data["fixed_by"];
        }
    }

    static fromJS(data: any): TrackPoint2 {
        data = typeof data === 'object' ? data : {};
        let result = new TrackPoint2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["accuracy"] = this.accuracy;
        data["device_mode"] = this.device_mode;
        data["battery_charge"] = this.battery_charge;
        data["fixed_by"] = this.fixed_by;
        return data;
    }
}

export interface ITrackPoint2 {
    timestamp?: moment.Moment;
    location?: Point;
    accuracy?: number;
    device_mode?: DeviceMode;
    battery_charge?: number;
    fixed_by?: CoordinateFixType;
}

export class RelativeTrackPoint extends TrackPoint2 implements IRelativeTrackPoint {
    speed?: number;
    speed_change?: number;
    distance?: number;
    duration?: number;
    activity_state?: ActivityState | undefined;
    speed_level?: SpeedLevel;

    constructor(data?: IRelativeTrackPoint) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.speed = _data["speed"];
            this.speed_change = _data["speed_change"];
            this.distance = _data["distance"];
            this.duration = _data["duration"];
            this.activity_state = _data["activity_state"];
            this.speed_level = _data["speed_level"];
        }
    }

    static override fromJS(data: any): RelativeTrackPoint {
        data = typeof data === 'object' ? data : {};
        let result = new RelativeTrackPoint();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speed"] = this.speed;
        data["speed_change"] = this.speed_change;
        data["distance"] = this.distance;
        data["duration"] = this.duration;
        data["activity_state"] = this.activity_state;
        data["speed_level"] = this.speed_level;
        super.toJSON(data);
        return data;
    }
}

export interface IRelativeTrackPoint extends ITrackPoint2 {
    speed?: number;
    speed_change?: number;
    distance?: number;
    duration?: number;
    activity_state?: ActivityState | undefined;
    speed_level?: SpeedLevel;
}

/** 0 = Sleep 1 = Step 3 = Gallop 6 = Run 255 = Relax */
export enum ActivityState {
    Sleep = 0,
    Step = 1,
    Gallop = 3,
    Run = 6,
    Relax = 255,
}

export class Point implements IPoint {
    lng?: number;
    lat?: number;
    alt?: number | undefined;

    [key: string]: any;

    constructor(data?: IPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.lng = _data["lng"];
            this.lat = _data["lat"];
            this.alt = _data["alt"];
        }
    }

    static fromJS(data: any): Point {
        data = typeof data === 'object' ? data : {};
        let result = new Point();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["alt"] = this.alt;
        return data;
    }
}

export interface IPoint {
    lng?: number;
    lat?: number;
    alt?: number | undefined;

    [key: string]: any;
}

export class DebugWalkParts implements IDebugWalkParts {
    id?: string;
    accuracy_percentile?: number | undefined;
    foot_kalman_decay?: number | undefined;
    car_kalman_decay?: number | undefined;
    bunch_area?: number | undefined;
    douglas_tolerance?: number | undefined;
    curve_level?: number | undefined;
    curve_strength?: number | undefined;

    constructor(data?: IDebugWalkParts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accuracy_percentile = _data["accuracy_percentile"];
            this.foot_kalman_decay = _data["foot_kalman_decay"];
            this.car_kalman_decay = _data["car_kalman_decay"];
            this.bunch_area = _data["bunch_area"];
            this.douglas_tolerance = _data["douglas_tolerance"];
            this.curve_level = _data["curve_level"];
            this.curve_strength = _data["curve_strength"];
        }
    }

    static fromJS(data: any): DebugWalkParts {
        data = typeof data === 'object' ? data : {};
        let result = new DebugWalkParts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accuracy_percentile"] = this.accuracy_percentile;
        data["foot_kalman_decay"] = this.foot_kalman_decay;
        data["car_kalman_decay"] = this.car_kalman_decay;
        data["bunch_area"] = this.bunch_area;
        data["douglas_tolerance"] = this.douglas_tolerance;
        data["curve_level"] = this.curve_level;
        data["curve_strength"] = this.curve_strength;
        return data;
    }
}

export interface IDebugWalkParts {
    id?: string;
    accuracy_percentile?: number | undefined;
    foot_kalman_decay?: number | undefined;
    car_kalman_decay?: number | undefined;
    bunch_area?: number | undefined;
    douglas_tolerance?: number | undefined;
    curve_level?: number | undefined;
    curve_strength?: number | undefined;
}

export class TrackPartial implements ITrackPartial {
    id?: string;
    started_at?: moment.Moment;
    started_at_zone?: string;
    rejected_reason?: TrackRejectedReason | undefined;

    constructor(data?: ITrackPartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.started_at = _data["started_at"] ? moment(_data["started_at"].toString()) : <any>undefined;
            this.started_at_zone = _data["started_at_zone"];
            this.rejected_reason = _data["rejected_reason"];
        }
    }

    static fromJS(data: any): TrackPartial {
        data = typeof data === 'object' ? data : {};
        let result = new TrackPartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["started_at"] = this.started_at ? this.started_at.toISOString() : <any>undefined;
        data["started_at_zone"] = this.started_at_zone;
        data["rejected_reason"] = this.rejected_reason;
        return data;
    }
}

export interface ITrackPartial {
    id?: string;
    started_at?: moment.Moment;
    started_at_zone?: string;
    rejected_reason?: TrackRejectedReason | undefined;
}

/** 0 = Distance 1 = Duration 2 = Points 3 = Unlink */
export enum TrackRejectedReason {
    Distance = 0,
    Duration = 1,
    Points = 2,
    Unlink = 3,
}

export class GetRejectedTracks implements IGetRejectedTracks {
    pet_id?: string;
    year?: number;
    month?: number;

    constructor(data?: IGetRejectedTracks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pet_id = _data["pet_id"];
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): GetRejectedTracks {
        data = typeof data === 'object' ? data : {};
        let result = new GetRejectedTracks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pet_id"] = this.pet_id;
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }
}

export interface IGetRejectedTracks {
    pet_id?: string;
    year?: number;
    month?: number;
}

export class StraightPart implements IStraightPart {
    steps_number?: number;
    activity_type?: string;
    points?: RelativeTrackPoint[];
    avg_speed?: number;
    distance_by_gps?: number;
    distance_by_activities?: number;
    steps_by_meter?: number;
    duration?: moment.Duration;
    ratio?: number;

    constructor(data?: IStraightPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.steps_number = _data["steps_number"];
            this.activity_type = _data["activity_type"];
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(RelativeTrackPoint.fromJS(item));
            }
            this.avg_speed = _data["avg_speed"];
            this.distance_by_gps = _data["distance_by_gps"];
            this.distance_by_activities = _data["distance_by_activities"];
            this.steps_by_meter = _data["steps_by_meter"];
            this.duration = _data["duration"] ? moment.duration(_data["duration"].toString()) : <any>undefined;
            this.ratio = _data["ratio"];
        }
    }

    static fromJS(data: any): StraightPart {
        data = typeof data === 'object' ? data : {};
        let result = new StraightPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["steps_number"] = this.steps_number;
        data["activity_type"] = this.activity_type;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["avg_speed"] = this.avg_speed;
        data["distance_by_gps"] = this.distance_by_gps;
        data["distance_by_activities"] = this.distance_by_activities;
        data["steps_by_meter"] = this.steps_by_meter;
        data["duration"] = this.duration ? this.duration.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["ratio"] = this.ratio;
        return data;
    }
}

export interface IStraightPart {
    steps_number?: number;
    activity_type?: string;
    points?: RelativeTrackPoint[];
    avg_speed?: number;
    distance_by_gps?: number;
    distance_by_activities?: number;
    steps_by_meter?: number;
    duration?: moment.Duration;
    ratio?: number;
}

export class GetStraightParts implements IGetStraightParts {
    track_id?: string;
    max_duration?: number | undefined;
    min_steps?: number | undefined;
    min_windows_number?: number | undefined;
    min_distance?: number | undefined;
    speed_dispersion?: number | undefined;
    max_two_points_distance?: number | undefined;
    max_two_points_duration?: number | undefined;
    max_accuracy?: number | undefined;
    window_points_number?: number | undefined;
    boundary_activity_and_point_delta?: number | undefined;

    constructor(data?: IGetStraightParts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.track_id = _data["track_id"];
            this.max_duration = _data["max_duration"];
            this.min_steps = _data["min_steps"];
            this.min_windows_number = _data["min_windows_number"];
            this.min_distance = _data["min_distance"];
            this.speed_dispersion = _data["speed_dispersion"];
            this.max_two_points_distance = _data["max_two_points_distance"];
            this.max_two_points_duration = _data["max_two_points_duration"];
            this.max_accuracy = _data["max_accuracy"];
            this.window_points_number = _data["window_points_number"];
            this.boundary_activity_and_point_delta = _data["boundary_activity_and_point_delta"];
        }
    }

    static fromJS(data: any): GetStraightParts {
        data = typeof data === 'object' ? data : {};
        let result = new GetStraightParts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["track_id"] = this.track_id;
        data["max_duration"] = this.max_duration;
        data["min_steps"] = this.min_steps;
        data["min_windows_number"] = this.min_windows_number;
        data["min_distance"] = this.min_distance;
        data["speed_dispersion"] = this.speed_dispersion;
        data["max_two_points_distance"] = this.max_two_points_distance;
        data["max_two_points_duration"] = this.max_two_points_duration;
        data["max_accuracy"] = this.max_accuracy;
        data["window_points_number"] = this.window_points_number;
        data["boundary_activity_and_point_delta"] = this.boundary_activity_and_point_delta;
        return data;
    }
}

export interface IGetStraightParts {
    track_id?: string;
    max_duration?: number | undefined;
    min_steps?: number | undefined;
    min_windows_number?: number | undefined;
    min_distance?: number | undefined;
    speed_dispersion?: number | undefined;
    max_two_points_distance?: number | undefined;
    max_two_points_duration?: number | undefined;
    max_accuracy?: number | undefined;
    window_points_number?: number | undefined;
    boundary_activity_and_point_delta?: number | undefined;
}

export class Track extends TrackPartial implements ITrack {
    ended_at?: moment.Moment | undefined;
    ended_at_zone?: string | undefined;
    points?: TrackPoint[];
    connections?: Connection[];
    stats?: ActivityStat[];
    length?: number;
    duration?: moment.Duration;

    constructor(data?: ITrack) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ended_at = _data["ended_at"] ? moment(_data["ended_at"].toString()) : <any>undefined;
            this.ended_at_zone = _data["ended_at_zone"];
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(TrackPoint.fromJS(item));
            }
            if (Array.isArray(_data["connections"])) {
                this.connections = [] as any;
                for (let item of _data["connections"])
                    this.connections!.push(Connection.fromJS(item));
            }
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(ActivityStat.fromJS(item));
            }
            this.length = _data["length"];
            this.duration = _data["duration"] ? moment.duration(_data["duration"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): Track {
        data = typeof data === 'object' ? data : {};
        let result = new Track();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ended_at"] = this.ended_at ? this.ended_at.toISOString() : <any>undefined;
        data["ended_at_zone"] = this.ended_at_zone;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        if (Array.isArray(this.connections)) {
            data["connections"] = [];
            for (let item of this.connections)
                data["connections"].push(item.toJSON());
        }
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item.toJSON());
        }
        data["length"] = this.length;
        data["duration"] = this.duration ? this.duration.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITrack extends ITrackPartial {
    ended_at?: moment.Moment | undefined;
    ended_at_zone?: string | undefined;
    points?: TrackPoint[];
    connections?: Connection[];
    stats?: ActivityStat[];
    length?: number;
    duration?: moment.Duration;
}

export class Connection implements IConnection {
    id?: string;
    duration?: moment.Duration;

    constructor(data?: IConnection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.duration = _data["duration"] ? moment.duration(_data["duration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Connection {
        data = typeof data === 'object' ? data : {};
        let result = new Connection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["duration"] = this.duration ? this.duration.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        return data;
    }
}

export interface IConnection {
    id?: string;
    duration?: moment.Duration;
}

export class ActivityStat implements IActivityStat {
    activity_type?: string;
    duration?: moment.Duration;
    steps?: number;
    distance?: number;
    percent_by_steps?: number;
    percent_by_distance?: number;
    percent_by_time?: number;

    constructor(data?: IActivityStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity_type = _data["activity_type"];
            this.duration = _data["duration"] ? moment.duration(_data["duration"].toString()) : <any>undefined;
            this.steps = _data["steps"];
            this.distance = _data["distance"];
            this.percent_by_steps = _data["percent_by_steps"];
            this.percent_by_distance = _data["percent_by_distance"];
            this.percent_by_time = _data["percent_by_time"];
        }
    }

    static fromJS(data: any): ActivityStat {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity_type"] = this.activity_type;
        data["duration"] = this.duration ? this.duration.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["steps"] = this.steps;
        data["distance"] = this.distance;
        data["percent_by_steps"] = this.percent_by_steps;
        data["percent_by_distance"] = this.percent_by_distance;
        data["percent_by_time"] = this.percent_by_time;
        return data;
    }
}

export interface IActivityStat {
    activity_type?: string;
    duration?: moment.Duration;
    steps?: number;
    distance?: number;
    percent_by_steps?: number;
    percent_by_distance?: number;
    percent_by_time?: number;
}

export class GetTrack implements IGetTrack {
    track_id?: string;

    constructor(data?: IGetTrack) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.track_id = _data["track_id"];
        }
    }

    static fromJS(data: any): GetTrack {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrack();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["track_id"] = this.track_id;
        return data;
    }
}

export interface IGetTrack {
    track_id?: string;
}

export class PagedListOfWalk implements IPagedListOfWalk {
    items!: Walk[];
    meta!: PagedListMeta;

    constructor(data?: IPagedListOfWalk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.meta = new PagedListMeta();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Walk.fromJS(item));
            }
            this.meta = _data["meta"] ? PagedListMeta.fromJS(_data["meta"]) : new PagedListMeta();
        }
    }

    static fromJS(data: any): PagedListOfWalk {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfWalk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedListOfWalk {
    items: Walk[];
    meta: PagedListMeta;
}

export class Walk implements IWalk {
    id?: string;
    started_at?: moment.Moment;
    ended_at?: moment.Moment | undefined;
    started_at_zone?: string;
    ended_at_zone?: string;
    distance?: number;
    preview?: string;
    calories?: number;
    steps?: number;
    run_time?: moment.Duration;
    rest_time?: moment.Duration;
    duration?: moment.Duration;
    pet?: PetPartial;
    owner?: CustomerPartial;

    constructor(data?: IWalk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.started_at = _data["started_at"] ? moment(_data["started_at"].toString()) : <any>undefined;
            this.ended_at = _data["ended_at"] ? moment(_data["ended_at"].toString()) : <any>undefined;
            this.started_at_zone = _data["started_at_zone"];
            this.ended_at_zone = _data["ended_at_zone"];
            this.distance = _data["distance"];
            this.preview = _data["preview"];
            this.calories = _data["calories"];
            this.steps = _data["steps"];
            this.run_time = _data["run_time"] ? moment.duration(_data["run_time"].toString()) : <any>undefined;
            this.rest_time = _data["rest_time"] ? moment.duration(_data["rest_time"].toString()) : <any>undefined;
            this.duration = _data["duration"] ? moment.duration(_data["duration"].toString()) : <any>undefined;
            this.pet = _data["pet"] ? PetPartial.fromJS(_data["pet"]) : <any>undefined;
            this.owner = _data["owner"] ? CustomerPartial.fromJS(_data["owner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Walk {
        data = typeof data === 'object' ? data : {};
        let result = new Walk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["started_at"] = this.started_at ? this.started_at.toISOString() : <any>undefined;
        data["ended_at"] = this.ended_at ? this.ended_at.toISOString() : <any>undefined;
        data["started_at_zone"] = this.started_at_zone;
        data["ended_at_zone"] = this.ended_at_zone;
        data["distance"] = this.distance;
        data["preview"] = this.preview;
        data["calories"] = this.calories;
        data["steps"] = this.steps;
        data["run_time"] = this.run_time ? this.run_time.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["rest_time"] = this.rest_time ? this.rest_time.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["duration"] = this.duration ? this.duration.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["pet"] = this.pet ? this.pet.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWalk {
    id?: string;
    started_at?: moment.Moment;
    ended_at?: moment.Moment | undefined;
    started_at_zone?: string;
    ended_at_zone?: string;
    distance?: number;
    preview?: string;
    calories?: number;
    steps?: number;
    run_time?: moment.Duration;
    rest_time?: moment.Duration;
    duration?: moment.Duration;
    pet?: PetPartial;
    owner?: CustomerPartial;
}

export class PetPartial implements IPetPartial {
    id?: string;
    alias?: string;
    sex?: Sex;
    avatar?: string | undefined;

    constructor(data?: IPetPartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
            this.sex = _data["sex"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): PetPartial {
        data = typeof data === 'object' ? data : {};
        let result = new PetPartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        data["sex"] = this.sex;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IPetPartial {
    id?: string;
    alias?: string;
    sex?: Sex;
    avatar?: string | undefined;
}

/** 0 = NotSet 1 = Male 2 = Female */
export enum Sex {
    NotSet = 0,
    Male = 1,
    Female = 2,
}

export class CustomerPartial implements ICustomerPartial {
    id?: string;
    email?: string;
    full_name?: string;
    avatar?: string | undefined;

    constructor(data?: ICustomerPartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.full_name = _data["full_name"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): CustomerPartial {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["full_name"] = this.full_name;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface ICustomerPartial {
    id?: string;
    email?: string;
    full_name?: string;
    avatar?: string | undefined;
}

export class PagedListMeta implements IPagedListMeta {
    total_count?: number;
    page_count?: number;
    current_page?: number;
    per_page?: number;

    constructor(data?: IPagedListMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total_count = _data["total_count"];
            this.page_count = _data["page_count"];
            this.current_page = _data["current_page"];
            this.per_page = _data["per_page"];
        }
    }

    static fromJS(data: any): PagedListMeta {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total_count"] = this.total_count;
        data["page_count"] = this.page_count;
        data["current_page"] = this.current_page;
        data["per_page"] = this.per_page;
        return data;
    }
}

export interface IPagedListMeta {
    total_count?: number;
    page_count?: number;
    current_page?: number;
    per_page?: number;
}

export class GetWalks implements IGetWalks {
    page?: number;
    page_size?: number;

    constructor(data?: IGetWalks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.page_size = _data["page_size"];
        }
    }

    static fromJS(data: any): GetWalks {
        data = typeof data === 'object' ? data : {};
        let result = new GetWalks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["page_size"] = this.page_size;
        return data;
    }
}

export interface IGetWalks {
    page?: number;
    page_size?: number;
}

export class SubscriptionInvoice implements ISubscriptionInvoice {
    paid?: boolean;
    number?: string;
    status?: string;
    amount_paid?: number;
    currency?: string;
    created?: moment.Moment;
    payments?: InvoicePayment[];

    constructor(data?: ISubscriptionInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paid = _data["paid"];
            this.number = _data["number"];
            this.status = _data["status"];
            this.amount_paid = _data["amount_paid"];
            this.currency = _data["currency"];
            this.created = _data["created"] ? moment(_data["created"].toString()) : <any>undefined;
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(InvoicePayment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paid"] = this.paid;
        data["number"] = this.number;
        data["status"] = this.status;
        data["amount_paid"] = this.amount_paid;
        data["currency"] = this.currency;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubscriptionInvoice {
    paid?: boolean;
    number?: string;
    status?: string;
    amount_paid?: number;
    currency?: string;
    created?: moment.Moment;
    payments?: InvoicePayment[];
}

export class InvoicePayment implements IInvoicePayment {
    id?: string;
    amount?: number;
    currency?: string;
    status?: string;
    description?: string;
    created?: moment.Moment;

    constructor(data?: IInvoicePayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.created = _data["created"] ? moment(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoicePayment {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["status"] = this.status;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInvoicePayment {
    id?: string;
    amount?: number;
    currency?: string;
    status?: string;
    description?: string;
    created?: moment.Moment;
}

export class GetInvoices implements IGetInvoices {
    pet_id?: string;

    constructor(data?: IGetInvoices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pet_id = _data["pet_id"];
        }
    }

    static fromJS(data: any): GetInvoices {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pet_id"] = this.pet_id;
        return data;
    }
}

export interface IGetInvoices {
    pet_id?: string;
}

export class PromoCode implements IPromoCode {
    code?: string;
    trial_days?: number;
    active?: boolean;
    linked_to?: CustomerPartial | undefined;
    usage_limit?: number;
    note?: string;
    valid_until?: moment.Moment | undefined;
    created_at?: moment.Moment;
    applies?: number;

    constructor(data?: IPromoCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.trial_days = _data["trial_days"];
            this.active = _data["active"];
            this.linked_to = _data["linked_to"] ? CustomerPartial.fromJS(_data["linked_to"]) : <any>undefined;
            this.usage_limit = _data["usage_limit"];
            this.note = _data["note"];
            this.valid_until = _data["valid_until"] ? moment(_data["valid_until"].toString()) : <any>undefined;
            this.created_at = _data["created_at"] ? moment(_data["created_at"].toString()) : <any>undefined;
            this.applies = _data["applies"];
        }
    }

    static fromJS(data: any): PromoCode {
        data = typeof data === 'object' ? data : {};
        let result = new PromoCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["trial_days"] = this.trial_days;
        data["active"] = this.active;
        data["linked_to"] = this.linked_to ? this.linked_to.toJSON() : <any>undefined;
        data["usage_limit"] = this.usage_limit;
        data["note"] = this.note;
        data["valid_until"] = this.valid_until ? this.valid_until.toISOString() : <any>undefined;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["applies"] = this.applies;
        return data;
    }
}

export interface IPromoCode {
    code?: string;
    trial_days?: number;
    active?: boolean;
    linked_to?: CustomerPartial | undefined;
    usage_limit?: number;
    note?: string;
    valid_until?: moment.Moment | undefined;
    created_at?: moment.Moment;
    applies?: number;
}

export class GetPromoCodes implements IGetPromoCodes {

    constructor(data?: IGetPromoCodes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPromoCodes {
        data = typeof data === 'object' ? data : {};
        let result = new GetPromoCodes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPromoCodes {
}

export class SubscriptionPlan implements ISubscriptionPlan {
    id?: string;
    interval?: string;
    interval_count?: number;
    subscription_descriptions?: SubscriptionDescription[];
    trial?: number | undefined;
    price?: number;
    created?: moment.Moment;
    active?: boolean;

    constructor(data?: ISubscriptionPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interval = _data["interval"];
            this.interval_count = _data["interval_count"];
            if (Array.isArray(_data["subscription_descriptions"])) {
                this.subscription_descriptions = [] as any;
                for (let item of _data["subscription_descriptions"])
                    this.subscription_descriptions!.push(SubscriptionDescription.fromJS(item));
            }
            this.trial = _data["trial"];
            this.price = _data["price"];
            this.created = _data["created"] ? moment(_data["created"].toString()) : <any>undefined;
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): SubscriptionPlan {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interval"] = this.interval;
        data["interval_count"] = this.interval_count;
        if (Array.isArray(this.subscription_descriptions)) {
            data["subscription_descriptions"] = [];
            for (let item of this.subscription_descriptions)
                data["subscription_descriptions"].push(item.toJSON());
        }
        data["trial"] = this.trial;
        data["price"] = this.price;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["active"] = this.active;
        return data;
    }
}

export interface ISubscriptionPlan {
    id?: string;
    interval?: string;
    interval_count?: number;
    subscription_descriptions?: SubscriptionDescription[];
    trial?: number | undefined;
    price?: number;
    created?: moment.Moment;
    active?: boolean;
}

export class SubscriptionDescription implements ISubscriptionDescription {
    lang?: string;
    name?: string | undefined;
    description?: string | undefined;
    label?: string | undefined;

    constructor(data?: ISubscriptionDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lang = _data["lang"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): SubscriptionDescription {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lang"] = this.lang;
        data["name"] = this.name;
        data["description"] = this.description;
        data["label"] = this.label;
        return data;
    }
}

export interface ISubscriptionDescription {
    lang?: string;
    name?: string | undefined;
    description?: string | undefined;
    label?: string | undefined;
}

export class GetSubscriptionPlans implements IGetSubscriptionPlans {

    constructor(data?: IGetSubscriptionPlans) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetSubscriptionPlans {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionPlans();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetSubscriptionPlans {
}

export class RequestError implements IRequestError {
    id?: string;
    timestamp?: moment.Moment;
    collar?: CollarPartial;
    pet?: PetPartial | undefined;
    owner?: CustomerPartial | undefined;
    flash_error?: boolean;
    battery_connection_error?: boolean;
    imu_error?: boolean;

    constructor(data?: IRequestError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.collar = _data["collar"] ? CollarPartial.fromJS(_data["collar"]) : <any>undefined;
            this.pet = _data["pet"] ? PetPartial.fromJS(_data["pet"]) : <any>undefined;
            this.owner = _data["owner"] ? CustomerPartial.fromJS(_data["owner"]) : <any>undefined;
            this.flash_error = _data["flash_error"];
            this.battery_connection_error = _data["battery_connection_error"];
            this.imu_error = _data["imu_error"];
        }
    }

    static fromJS(data: any): RequestError {
        data = typeof data === 'object' ? data : {};
        let result = new RequestError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["collar"] = this.collar ? this.collar.toJSON() : <any>undefined;
        data["pet"] = this.pet ? this.pet.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["flash_error"] = this.flash_error;
        data["battery_connection_error"] = this.battery_connection_error;
        data["imu_error"] = this.imu_error;
        return data;
    }
}

export interface IRequestError {
    id?: string;
    timestamp?: moment.Moment;
    collar?: CollarPartial;
    pet?: PetPartial | undefined;
    owner?: CustomerPartial | undefined;
    flash_error?: boolean;
    battery_connection_error?: boolean;
    imu_error?: boolean;
}

export class CollarPartial implements ICollarPartial {
    id?: string;
    revision?: string;

    constructor(data?: ICollarPartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.revision = _data["revision"];
        }
    }

    static fromJS(data: any): CollarPartial {
        data = typeof data === 'object' ? data : {};
        let result = new CollarPartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["revision"] = this.revision;
        return data;
    }
}

export interface ICollarPartial {
    id?: string;
    revision?: string;
}

export class GetRequestErrors implements IGetRequestErrors {

    constructor(data?: IGetRequestErrors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRequestErrors {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestErrors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRequestErrors {
}

export class PagedListOfRequestSnapshot implements IPagedListOfRequestSnapshot {
    items!: RequestSnapshot[];
    meta!: PagedListMeta;

    constructor(data?: IPagedListOfRequestSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.meta = new PagedListMeta();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RequestSnapshot.fromJS(item));
            }
            this.meta = _data["meta"] ? PagedListMeta.fromJS(_data["meta"]) : new PagedListMeta();
        }
    }

    static fromJS(data: any): PagedListOfRequestSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfRequestSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedListOfRequestSnapshot {
    items: RequestSnapshot[];
    meta: PagedListMeta;
}

export class RequestSnapshot implements IRequestSnapshot {
    id?: string;
    created_at?: moment.Moment;
    time_zone?: string;
    remote_ip?: string;
    firmware_version?: string;
    device_id?: string;
    headers?: { [key: string]: any; };
    ver_s_zones?: number;
    request_packets?: RequestPacket[];
    request_hex?: string;
    request_crc?: string;
    response_packets?: RequestPacket[];
    response_status?: BtpStatusCode;
    response_hex?: string;
    response_crc?: string;
    protocol?: string;
    elapsed?: number;

    constructor(data?: IRequestSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created_at = _data["created_at"] ? moment(_data["created_at"].toString()) : <any>undefined;
            this.time_zone = _data["time_zone"];
            this.remote_ip = _data["remote_ip"];
            this.firmware_version = _data["firmware_version"];
            this.device_id = _data["device_id"];
            if (_data["headers"]) {
                this.headers = {} as any;
                for (let key in _data["headers"]) {
                    if (_data["headers"].hasOwnProperty(key))
                        (<any>this.headers)![key] = _data["headers"][key];
                }
            }
            this.ver_s_zones = _data["ver_s_zones"];
            if (Array.isArray(_data["request_packets"])) {
                this.request_packets = [] as any;
                for (let item of _data["request_packets"])
                    this.request_packets!.push(RequestPacket.fromJS(item));
            }
            this.request_hex = _data["request_hex"];
            this.request_crc = _data["request_crc"];
            if (Array.isArray(_data["response_packets"])) {
                this.response_packets = [] as any;
                for (let item of _data["response_packets"])
                    this.response_packets!.push(RequestPacket.fromJS(item));
            }
            this.response_status = _data["response_status"];
            this.response_hex = _data["response_hex"];
            this.response_crc = _data["response_crc"];
            this.protocol = _data["protocol"];
            this.elapsed = _data["elapsed"];
        }
    }

    static fromJS(data: any): RequestSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new RequestSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["time_zone"] = this.time_zone;
        data["remote_ip"] = this.remote_ip;
        data["firmware_version"] = this.firmware_version;
        data["device_id"] = this.device_id;
        if (this.headers) {
            data["headers"] = {};
            for (let key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    (<any>data["headers"])[key] = (<any>this.headers)[key];
            }
        }
        data["ver_s_zones"] = this.ver_s_zones;
        if (Array.isArray(this.request_packets)) {
            data["request_packets"] = [];
            for (let item of this.request_packets)
                data["request_packets"].push(item.toJSON());
        }
        data["request_hex"] = this.request_hex;
        data["request_crc"] = this.request_crc;
        if (Array.isArray(this.response_packets)) {
            data["response_packets"] = [];
            for (let item of this.response_packets)
                data["response_packets"].push(item.toJSON());
        }
        data["response_status"] = this.response_status;
        data["response_hex"] = this.response_hex;
        data["response_crc"] = this.response_crc;
        data["protocol"] = this.protocol;
        data["elapsed"] = this.elapsed;
        return data;
    }
}

export interface IRequestSnapshot {
    id?: string;
    created_at?: moment.Moment;
    time_zone?: string;
    remote_ip?: string;
    firmware_version?: string;
    device_id?: string;
    headers?: { [key: string]: any; };
    ver_s_zones?: number;
    request_packets?: RequestPacket[];
    request_hex?: string;
    request_crc?: string;
    response_packets?: RequestPacket[];
    response_status?: BtpStatusCode;
    response_hex?: string;
    response_crc?: string;
    protocol?: string;
    elapsed?: number;
}

export class RequestPacket implements IRequestPacket {
    packet_type?: number;
    parsed?: { [key: string]: any; };

    constructor(data?: IRequestPacket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packet_type = _data["packet_type"];
            if (_data["parsed"]) {
                this.parsed = {} as any;
                for (let key in _data["parsed"]) {
                    if (_data["parsed"].hasOwnProperty(key))
                        (<any>this.parsed)![key] = _data["parsed"][key];
                }
            }
        }
    }

    static fromJS(data: any): RequestPacket {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPacket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packet_type"] = this.packet_type;
        if (this.parsed) {
            data["parsed"] = {};
            for (let key in this.parsed) {
                if (this.parsed.hasOwnProperty(key))
                    (<any>data["parsed"])[key] = (<any>this.parsed)[key];
            }
        }
        return data;
    }
}

export interface IRequestPacket {
    packet_type?: number;
    parsed?: { [key: string]: any; };
}

/** 20 = OK 40 = BadRequest 50 = InternalServerError */
export enum BtpStatusCode {
    OK = 20,
    BadRequest = 40,
    InternalServerError = 50,
}

export class RequestFilter implements IRequestFilter {
    id?: string | undefined;
    start_date_request?: moment.Moment | undefined;
    end_date_request?: moment.Moment | undefined;
    start_date_packet?: moment.Moment | undefined;
    end_date_packet?: moment.Moment | undefined;
    packet_types?: number[] | undefined;
    device_id?: string | undefined;
    response_status?: BtpStatusCode | undefined;
    battery_id?: string | undefined;
    parameters?: string | undefined;
    module_id?: number | undefined;
    error_code?: number | undefined;
    distinct_packets?: boolean;
    page?: number;
    page_size?: number;
    sort_by?: string | undefined;
    sort_order?: SortOrder;
    sort_packets_by?: string | undefined;
    sort_packets_order?: SortOrder;

    constructor(data?: IRequestFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.start_date_request = _data["start_date_request"] ? moment(_data["start_date_request"].toString()) : <any>undefined;
            this.end_date_request = _data["end_date_request"] ? moment(_data["end_date_request"].toString()) : <any>undefined;
            this.start_date_packet = _data["start_date_packet"] ? moment(_data["start_date_packet"].toString()) : <any>undefined;
            this.end_date_packet = _data["end_date_packet"] ? moment(_data["end_date_packet"].toString()) : <any>undefined;
            if (Array.isArray(_data["packet_types"])) {
                this.packet_types = [] as any;
                for (let item of _data["packet_types"])
                    this.packet_types!.push(item);
            }
            this.device_id = _data["device_id"];
            this.response_status = _data["response_status"];
            this.battery_id = _data["battery_id"];
            this.parameters = _data["parameters"];
            this.module_id = _data["module_id"];
            this.error_code = _data["error_code"];
            this.distinct_packets = _data["distinct_packets"];
            this.page = _data["page"];
            this.page_size = _data["page_size"];
            this.sort_by = _data["sort_by"];
            this.sort_order = _data["sort_order"];
            this.sort_packets_by = _data["sort_packets_by"];
            this.sort_packets_order = _data["sort_packets_order"];
        }
    }

    static fromJS(data: any): RequestFilter {
        data = typeof data === 'object' ? data : {};
        let result = new RequestFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["start_date_request"] = this.start_date_request ? this.start_date_request.toISOString() : <any>undefined;
        data["end_date_request"] = this.end_date_request ? this.end_date_request.toISOString() : <any>undefined;
        data["start_date_packet"] = this.start_date_packet ? this.start_date_packet.toISOString() : <any>undefined;
        data["end_date_packet"] = this.end_date_packet ? this.end_date_packet.toISOString() : <any>undefined;
        if (Array.isArray(this.packet_types)) {
            data["packet_types"] = [];
            for (let item of this.packet_types)
                data["packet_types"].push(item);
        }
        data["device_id"] = this.device_id;
        data["response_status"] = this.response_status;
        data["battery_id"] = this.battery_id;
        data["parameters"] = this.parameters;
        data["module_id"] = this.module_id;
        data["error_code"] = this.error_code;
        data["distinct_packets"] = this.distinct_packets;
        data["page"] = this.page;
        data["page_size"] = this.page_size;
        data["sort_by"] = this.sort_by;
        data["sort_order"] = this.sort_order;
        data["sort_packets_by"] = this.sort_packets_by;
        data["sort_packets_order"] = this.sort_packets_order;
        return data;
    }
}

export interface IRequestFilter {
    id?: string | undefined;
    start_date_request?: moment.Moment | undefined;
    end_date_request?: moment.Moment | undefined;
    start_date_packet?: moment.Moment | undefined;
    end_date_packet?: moment.Moment | undefined;
    packet_types?: number[] | undefined;
    device_id?: string | undefined;
    response_status?: BtpStatusCode | undefined;
    battery_id?: string | undefined;
    parameters?: string | undefined;
    module_id?: number | undefined;
    error_code?: number | undefined;
    distinct_packets?: boolean;
    page?: number;
    page_size?: number;
    sort_by?: string | undefined;
    sort_order?: SortOrder;
    sort_packets_by?: string | undefined;
    sort_packets_order?: SortOrder;
}

export class GetRequests extends RequestFilter implements IGetRequests {

    constructor(data?: IGetRequests) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetRequests {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequests();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetRequests extends IRequestFilter {
}

/** 0 = Ascending 1 = Descending */
export enum SortOrder {
    Ascending = 0,
    Descending = 1,
}

export class GetPetOwner implements IGetPetOwner {
    pet_id?: string;

    constructor(data?: IGetPetOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pet_id = _data["pet_id"];
        }
    }

    static fromJS(data: any): GetPetOwner {
        data = typeof data === 'object' ? data : {};
        let result = new GetPetOwner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pet_id"] = this.pet_id;
        return data;
    }
}

export interface IGetPetOwner {
    pet_id?: string;
}

export class FirmwareResponse implements IFirmwareResponse {
    id?: string;
    version?: string;
    revision?: string;
    status?: FirmwareStatus;
    description?: { [key: string]: string; };
    note?: string;
    percent_for_testing?: number;
    reviews?: FirmwareReviewResponse[];
    update_date?: moment.Moment;
    create_date?: moment.Moment;

    constructor(data?: IFirmwareResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
            this.revision = _data["revision"];
            this.status = _data["status"];
            if (_data["description"]) {
                this.description = {} as any;
                for (let key in _data["description"]) {
                    if (_data["description"].hasOwnProperty(key))
                        (<any>this.description)![key] = _data["description"][key];
                }
            }
            this.note = _data["note"];
            this.percent_for_testing = _data["percent_for_testing"];
            if (Array.isArray(_data["reviews"])) {
                this.reviews = [] as any;
                for (let item of _data["reviews"])
                    this.reviews!.push(FirmwareReviewResponse.fromJS(item));
            }
            this.update_date = _data["update_date"] ? moment(_data["update_date"].toString()) : <any>undefined;
            this.create_date = _data["create_date"] ? moment(_data["create_date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FirmwareResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        data["revision"] = this.revision;
        data["status"] = this.status;
        if (this.description) {
            data["description"] = {};
            for (let key in this.description) {
                if (this.description.hasOwnProperty(key))
                    (<any>data["description"])[key] = (<any>this.description)[key];
            }
        }
        data["note"] = this.note;
        data["percent_for_testing"] = this.percent_for_testing;
        if (Array.isArray(this.reviews)) {
            data["reviews"] = [];
            for (let item of this.reviews)
                data["reviews"].push(item.toJSON());
        }
        data["update_date"] = this.update_date ? this.update_date.toISOString() : <any>undefined;
        data["create_date"] = this.create_date ? this.create_date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFirmwareResponse {
    id?: string;
    version?: string;
    revision?: string;
    status?: FirmwareStatus;
    description?: { [key: string]: string; };
    note?: string;
    percent_for_testing?: number;
    reviews?: FirmwareReviewResponse[];
    update_date?: moment.Moment;
    create_date?: moment.Moment;
}

/** Общее состояние прошивки            1 = Active 8 = Disabled */
export enum FirmwareStatus {
    Active = 1,
    Disabled = 8,
}

export class FirmwareReviewResponse extends UserPartialResponse implements IFirmwareReviewResponse {
    reviewed?: boolean;

    constructor(data?: IFirmwareReviewResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reviewed = _data["reviewed"];
        }
    }

    static override fromJS(data: any): FirmwareReviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareReviewResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reviewed"] = this.reviewed;
        super.toJSON(data);
        return data;
    }
}

export interface IFirmwareReviewResponse extends IUserPartialResponse {
    reviewed?: boolean;
}

export class GetFirmwaresQuery implements IGetFirmwaresQuery {

    constructor(data?: IGetFirmwaresQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetFirmwaresQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFirmwaresQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetFirmwaresQuery {
}

export class DictionaryResponse implements IDictionaryResponse {
    activities?: { [key: string]: string; };
    user_statuses?: { [key: string]: string; };
    device_modes?: { [key: string]: string; };
    fix_types?: { [key: string]: string; };
    device_statuses?: { [key: string]: string; };
    firmware_statuses?: { [key: string]: string; };
    packet_types?: { [key: string]: string; };
    response_data_statuses?: { [key: string]: string; };
    safe_zone_types?: { [key: string]: string; };
    track_rejected_reason?: { [key: string]: string; };
    sex?: { [key: string]: string; };
    transports?: { [key: string]: string; };
    subscription_status?: { [key: string]: string; };
    wi_fi_states?: { [key: string]: string; };
    share_levels?: { [key: string]: string; };
    error_modules?: { [key: string]: string; };
    error_codes?: { [key: string]: { [key: string]: string; }; };

    constructor(data?: IDictionaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["activities"]) {
                this.activities = {} as any;
                for (let key in _data["activities"]) {
                    if (_data["activities"].hasOwnProperty(key))
                        (<any>this.activities)![key] = _data["activities"][key];
                }
            }
            if (_data["user_statuses"]) {
                this.user_statuses = {} as any;
                for (let key in _data["user_statuses"]) {
                    if (_data["user_statuses"].hasOwnProperty(key))
                        (<any>this.user_statuses)![key] = _data["user_statuses"][key];
                }
            }
            if (_data["device_modes"]) {
                this.device_modes = {} as any;
                for (let key in _data["device_modes"]) {
                    if (_data["device_modes"].hasOwnProperty(key))
                        (<any>this.device_modes)![key] = _data["device_modes"][key];
                }
            }
            if (_data["fix_types"]) {
                this.fix_types = {} as any;
                for (let key in _data["fix_types"]) {
                    if (_data["fix_types"].hasOwnProperty(key))
                        (<any>this.fix_types)![key] = _data["fix_types"][key];
                }
            }
            if (_data["device_statuses"]) {
                this.device_statuses = {} as any;
                for (let key in _data["device_statuses"]) {
                    if (_data["device_statuses"].hasOwnProperty(key))
                        (<any>this.device_statuses)![key] = _data["device_statuses"][key];
                }
            }
            if (_data["firmware_statuses"]) {
                this.firmware_statuses = {} as any;
                for (let key in _data["firmware_statuses"]) {
                    if (_data["firmware_statuses"].hasOwnProperty(key))
                        (<any>this.firmware_statuses)![key] = _data["firmware_statuses"][key];
                }
            }
            if (_data["packet_types"]) {
                this.packet_types = {} as any;
                for (let key in _data["packet_types"]) {
                    if (_data["packet_types"].hasOwnProperty(key))
                        (<any>this.packet_types)![key] = _data["packet_types"][key];
                }
            }
            if (_data["response_data_statuses"]) {
                this.response_data_statuses = {} as any;
                for (let key in _data["response_data_statuses"]) {
                    if (_data["response_data_statuses"].hasOwnProperty(key))
                        (<any>this.response_data_statuses)![key] = _data["response_data_statuses"][key];
                }
            }
            if (_data["safe_zone_types"]) {
                this.safe_zone_types = {} as any;
                for (let key in _data["safe_zone_types"]) {
                    if (_data["safe_zone_types"].hasOwnProperty(key))
                        (<any>this.safe_zone_types)![key] = _data["safe_zone_types"][key];
                }
            }
            if (_data["track_rejected_reason"]) {
                this.track_rejected_reason = {} as any;
                for (let key in _data["track_rejected_reason"]) {
                    if (_data["track_rejected_reason"].hasOwnProperty(key))
                        (<any>this.track_rejected_reason)![key] = _data["track_rejected_reason"][key];
                }
            }
            if (_data["sex"]) {
                this.sex = {} as any;
                for (let key in _data["sex"]) {
                    if (_data["sex"].hasOwnProperty(key))
                        (<any>this.sex)![key] = _data["sex"][key];
                }
            }
            if (_data["transports"]) {
                this.transports = {} as any;
                for (let key in _data["transports"]) {
                    if (_data["transports"].hasOwnProperty(key))
                        (<any>this.transports)![key] = _data["transports"][key];
                }
            }
            if (_data["subscription_status"]) {
                this.subscription_status = {} as any;
                for (let key in _data["subscription_status"]) {
                    if (_data["subscription_status"].hasOwnProperty(key))
                        (<any>this.subscription_status)![key] = _data["subscription_status"][key];
                }
            }
            if (_data["wi_fi_states"]) {
                this.wi_fi_states = {} as any;
                for (let key in _data["wi_fi_states"]) {
                    if (_data["wi_fi_states"].hasOwnProperty(key))
                        (<any>this.wi_fi_states)![key] = _data["wi_fi_states"][key];
                }
            }
            if (_data["share_levels"]) {
                this.share_levels = {} as any;
                for (let key in _data["share_levels"]) {
                    if (_data["share_levels"].hasOwnProperty(key))
                        (<any>this.share_levels)![key] = _data["share_levels"][key];
                }
            }
            if (_data["error_modules"]) {
                this.error_modules = {} as any;
                for (let key in _data["error_modules"]) {
                    if (_data["error_modules"].hasOwnProperty(key))
                        (<any>this.error_modules)![key] = _data["error_modules"][key];
                }
            }
            if (_data["error_codes"]) {
                this.error_codes = {} as any;
                for (let key in _data["error_codes"]) {
                    if (_data["error_codes"].hasOwnProperty(key))
                        (<any>this.error_codes)![key] = _data["error_codes"][key] !== undefined ? _data["error_codes"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): DictionaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DictionaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.activities) {
            data["activities"] = {};
            for (let key in this.activities) {
                if (this.activities.hasOwnProperty(key))
                    (<any>data["activities"])[key] = (<any>this.activities)[key];
            }
        }
        if (this.user_statuses) {
            data["user_statuses"] = {};
            for (let key in this.user_statuses) {
                if (this.user_statuses.hasOwnProperty(key))
                    (<any>data["user_statuses"])[key] = (<any>this.user_statuses)[key];
            }
        }
        if (this.device_modes) {
            data["device_modes"] = {};
            for (let key in this.device_modes) {
                if (this.device_modes.hasOwnProperty(key))
                    (<any>data["device_modes"])[key] = (<any>this.device_modes)[key];
            }
        }
        if (this.fix_types) {
            data["fix_types"] = {};
            for (let key in this.fix_types) {
                if (this.fix_types.hasOwnProperty(key))
                    (<any>data["fix_types"])[key] = (<any>this.fix_types)[key];
            }
        }
        if (this.device_statuses) {
            data["device_statuses"] = {};
            for (let key in this.device_statuses) {
                if (this.device_statuses.hasOwnProperty(key))
                    (<any>data["device_statuses"])[key] = (<any>this.device_statuses)[key];
            }
        }
        if (this.firmware_statuses) {
            data["firmware_statuses"] = {};
            for (let key in this.firmware_statuses) {
                if (this.firmware_statuses.hasOwnProperty(key))
                    (<any>data["firmware_statuses"])[key] = (<any>this.firmware_statuses)[key];
            }
        }
        if (this.packet_types) {
            data["packet_types"] = {};
            for (let key in this.packet_types) {
                if (this.packet_types.hasOwnProperty(key))
                    (<any>data["packet_types"])[key] = (<any>this.packet_types)[key];
            }
        }
        if (this.response_data_statuses) {
            data["response_data_statuses"] = {};
            for (let key in this.response_data_statuses) {
                if (this.response_data_statuses.hasOwnProperty(key))
                    (<any>data["response_data_statuses"])[key] = (<any>this.response_data_statuses)[key];
            }
        }
        if (this.safe_zone_types) {
            data["safe_zone_types"] = {};
            for (let key in this.safe_zone_types) {
                if (this.safe_zone_types.hasOwnProperty(key))
                    (<any>data["safe_zone_types"])[key] = (<any>this.safe_zone_types)[key];
            }
        }
        if (this.track_rejected_reason) {
            data["track_rejected_reason"] = {};
            for (let key in this.track_rejected_reason) {
                if (this.track_rejected_reason.hasOwnProperty(key))
                    (<any>data["track_rejected_reason"])[key] = (<any>this.track_rejected_reason)[key];
            }
        }
        if (this.sex) {
            data["sex"] = {};
            for (let key in this.sex) {
                if (this.sex.hasOwnProperty(key))
                    (<any>data["sex"])[key] = (<any>this.sex)[key];
            }
        }
        if (this.transports) {
            data["transports"] = {};
            for (let key in this.transports) {
                if (this.transports.hasOwnProperty(key))
                    (<any>data["transports"])[key] = (<any>this.transports)[key];
            }
        }
        if (this.subscription_status) {
            data["subscription_status"] = {};
            for (let key in this.subscription_status) {
                if (this.subscription_status.hasOwnProperty(key))
                    (<any>data["subscription_status"])[key] = (<any>this.subscription_status)[key];
            }
        }
        if (this.wi_fi_states) {
            data["wi_fi_states"] = {};
            for (let key in this.wi_fi_states) {
                if (this.wi_fi_states.hasOwnProperty(key))
                    (<any>data["wi_fi_states"])[key] = (<any>this.wi_fi_states)[key];
            }
        }
        if (this.share_levels) {
            data["share_levels"] = {};
            for (let key in this.share_levels) {
                if (this.share_levels.hasOwnProperty(key))
                    (<any>data["share_levels"])[key] = (<any>this.share_levels)[key];
            }
        }
        if (this.error_modules) {
            data["error_modules"] = {};
            for (let key in this.error_modules) {
                if (this.error_modules.hasOwnProperty(key))
                    (<any>data["error_modules"])[key] = (<any>this.error_modules)[key];
            }
        }
        if (this.error_codes) {
            data["error_codes"] = {};
            for (let key in this.error_codes) {
                if (this.error_codes.hasOwnProperty(key))
                    (<any>data["error_codes"])[key] = (<any>this.error_codes)[key];
            }
        }
        return data;
    }
}

export interface IDictionaryResponse {
    activities?: { [key: string]: string; };
    user_statuses?: { [key: string]: string; };
    device_modes?: { [key: string]: string; };
    fix_types?: { [key: string]: string; };
    device_statuses?: { [key: string]: string; };
    firmware_statuses?: { [key: string]: string; };
    packet_types?: { [key: string]: string; };
    response_data_statuses?: { [key: string]: string; };
    safe_zone_types?: { [key: string]: string; };
    track_rejected_reason?: { [key: string]: string; };
    sex?: { [key: string]: string; };
    transports?: { [key: string]: string; };
    subscription_status?: { [key: string]: string; };
    wi_fi_states?: { [key: string]: string; };
    share_levels?: { [key: string]: string; };
    error_modules?: { [key: string]: string; };
    error_codes?: { [key: string]: { [key: string]: string; }; };
}

export class GetDictionariesQuery implements IGetDictionariesQuery {

    constructor(data?: IGetDictionariesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetDictionariesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDictionariesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetDictionariesQuery {
}

export class PagedListOfBattery implements IPagedListOfBattery {
    items!: Battery[];
    meta!: PagedListMeta;

    constructor(data?: IPagedListOfBattery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.meta = new PagedListMeta();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Battery.fromJS(item));
            }
            this.meta = _data["meta"] ? PagedListMeta.fromJS(_data["meta"]) : new PagedListMeta();
        }
    }

    static fromJS(data: any): PagedListOfBattery {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfBattery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedListOfBattery {
    items: Battery[];
    meta: PagedListMeta;
}

export class Battery implements IBattery {
    id?: string;
    serial?: string;
    created_at?: moment.Moment;

    constructor(data?: IBattery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serial = _data["serial"];
            this.created_at = _data["created_at"] ? moment(_data["created_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Battery {
        data = typeof data === 'object' ? data : {};
        let result = new Battery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serial"] = this.serial;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBattery {
    id?: string;
    serial?: string;
    created_at?: moment.Moment;
}

export class GetBatteries implements IGetBatteries {
    keywords?: string | undefined;
    page?: number;
    page_size?: number;
    sort_by?: string | undefined;
    sort_order?: SortOrder;

    constructor(data?: IGetBatteries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keywords = _data["keywords"];
            this.page = _data["page"];
            this.page_size = _data["page_size"];
            this.sort_by = _data["sort_by"];
            this.sort_order = _data["sort_order"];
        }
    }

    static fromJS(data: any): GetBatteries {
        data = typeof data === 'object' ? data : {};
        let result = new GetBatteries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords;
        data["page"] = this.page;
        data["page_size"] = this.page_size;
        data["sort_by"] = this.sort_by;
        data["sort_order"] = this.sort_order;
        return data;
    }
}

export interface IGetBatteries {
    keywords?: string | undefined;
    page?: number;
    page_size?: number;
    sort_by?: string | undefined;
    sort_order?: SortOrder;
}

export class PagedListOfBeacon implements IPagedListOfBeacon {
    items!: Beacon[];
    meta!: PagedListMeta;

    constructor(data?: IPagedListOfBeacon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.meta = new PagedListMeta();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Beacon.fromJS(item));
            }
            this.meta = _data["meta"] ? PagedListMeta.fromJS(_data["meta"]) : new PagedListMeta();
        }
    }

    static fromJS(data: any): PagedListOfBeacon {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfBeacon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedListOfBeacon {
    items: Beacon[];
    meta: PagedListMeta;
}

export class Beacon implements IBeacon {
    mac_address?: string;
    serial?: string;
    created_at?: moment.Moment;

    constructor(data?: IBeacon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mac_address = _data["mac_address"];
            this.serial = _data["serial"];
            this.created_at = _data["created_at"] ? moment(_data["created_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Beacon {
        data = typeof data === 'object' ? data : {};
        let result = new Beacon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mac_address"] = this.mac_address;
        data["serial"] = this.serial;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBeacon {
    mac_address?: string;
    serial?: string;
    created_at?: moment.Moment;
}

export class GetBeacons implements IGetBeacons {
    keywords?: string | undefined;
    page?: number;
    page_size?: number;
    sort_by?: string | undefined;
    sort_order?: SortOrder;

    constructor(data?: IGetBeacons) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keywords = _data["keywords"];
            this.page = _data["page"];
            this.page_size = _data["page_size"];
            this.sort_by = _data["sort_by"];
            this.sort_order = _data["sort_order"];
        }
    }

    static fromJS(data: any): GetBeacons {
        data = typeof data === 'object' ? data : {};
        let result = new GetBeacons();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords;
        data["page"] = this.page;
        data["page_size"] = this.page_size;
        data["sort_by"] = this.sort_by;
        data["sort_order"] = this.sort_order;
        return data;
    }
}

export interface IGetBeacons {
    keywords?: string | undefined;
    page?: number;
    page_size?: number;
    sort_by?: string | undefined;
    sort_order?: SortOrder;
}

export class DeviceBatteryInfoResponse implements IDeviceBatteryInfoResponse {
    battery_charges?: BatteryChargeInfo[];
    batteries_info?: BatteryInfo[];

    constructor(data?: IDeviceBatteryInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["battery_charges"])) {
                this.battery_charges = [] as any;
                for (let item of _data["battery_charges"])
                    this.battery_charges!.push(BatteryChargeInfo.fromJS(item));
            }
            if (Array.isArray(_data["batteries_info"])) {
                this.batteries_info = [] as any;
                for (let item of _data["batteries_info"])
                    this.batteries_info!.push(BatteryInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceBatteryInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceBatteryInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.battery_charges)) {
            data["battery_charges"] = [];
            for (let item of this.battery_charges)
                data["battery_charges"].push(item.toJSON());
        }
        if (Array.isArray(this.batteries_info)) {
            data["batteries_info"] = [];
            for (let item of this.batteries_info)
                data["batteries_info"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeviceBatteryInfoResponse {
    battery_charges?: BatteryChargeInfo[];
    batteries_info?: BatteryInfo[];
}

export class BatteryChargeInfo implements IBatteryChargeInfo {
    timestamp?: number | undefined;
    battery_charge?: number | undefined;

    constructor(data?: IBatteryChargeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"];
            this.battery_charge = _data["battery_charge"];
        }
    }

    static fromJS(data: any): BatteryChargeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryChargeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp;
        data["battery_charge"] = this.battery_charge;
        return data;
    }
}

export interface IBatteryChargeInfo {
    timestamp?: number | undefined;
    battery_charge?: number | undefined;
}

export class BatteryInfo implements IBatteryInfo {
    start_time?: number | undefined;
    end_time?: number | undefined;
    battery_id?: string;
    spec_parmeters?: BatterySpecParmeterInfo[];

    constructor(data?: IBatteryInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start_time = _data["start_time"];
            this.end_time = _data["end_time"];
            this.battery_id = _data["battery_id"];
            if (Array.isArray(_data["spec_parmeters"])) {
                this.spec_parmeters = [] as any;
                for (let item of _data["spec_parmeters"])
                    this.spec_parmeters!.push(BatterySpecParmeterInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatteryInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start_time"] = this.start_time;
        data["end_time"] = this.end_time;
        data["battery_id"] = this.battery_id;
        if (Array.isArray(this.spec_parmeters)) {
            data["spec_parmeters"] = [];
            for (let item of this.spec_parmeters)
                data["spec_parmeters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatteryInfo {
    start_time?: number | undefined;
    end_time?: number | undefined;
    battery_id?: string;
    spec_parmeters?: BatterySpecParmeterInfo[];
}

export class BatterySpecParmeterInfo implements IBatterySpecParmeterInfo {
    timestamp?: number | undefined;
    /** начальная емкость батареи (мА*ч) */
    design_capacity?: number;
    /** полная остаточная емкость батареи (мА*ч) */
    full_cap?: number;
    /** кол-во циклов заряда-разряда батареи */
    n_cycles?: number;
    /** текущая емкость батареи (мА*ч) */
    cur_capacity?: number;
    /** текущее напряжение (мВ) */
    cur_voltage?: number;

    constructor(data?: IBatterySpecParmeterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"];
            this.design_capacity = _data["design_capacity"];
            this.full_cap = _data["full_cap"];
            this.n_cycles = _data["n_cycles"];
            this.cur_capacity = _data["cur_capacity"];
            this.cur_voltage = _data["cur_voltage"];
        }
    }

    static fromJS(data: any): BatterySpecParmeterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BatterySpecParmeterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp;
        data["design_capacity"] = this.design_capacity;
        data["full_cap"] = this.full_cap;
        data["n_cycles"] = this.n_cycles;
        data["cur_capacity"] = this.cur_capacity;
        data["cur_voltage"] = this.cur_voltage;
        return data;
    }
}

export interface IBatterySpecParmeterInfo {
    timestamp?: number | undefined;
    /** начальная емкость батареи (мА*ч) */
    design_capacity?: number;
    /** полная остаточная емкость батареи (мА*ч) */
    full_cap?: number;
    /** кол-во циклов заряда-разряда батареи */
    n_cycles?: number;
    /** текущая емкость батареи (мА*ч) */
    cur_capacity?: number;
    /** текущее напряжение (мВ) */
    cur_voltage?: number;
}

export class GetCollarBattery implements IGetCollarBattery {
    device_id?: string | undefined;
    start_date?: moment.Moment | undefined;
    end_date?: moment.Moment | undefined;
    avg?: number;

    constructor(data?: IGetCollarBattery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_id = _data["device_id"];
            this.start_date = _data["start_date"] ? moment(_data["start_date"].toString()) : <any>undefined;
            this.end_date = _data["end_date"] ? moment(_data["end_date"].toString()) : <any>undefined;
            this.avg = _data["avg"];
        }
    }

    static fromJS(data: any): GetCollarBattery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCollarBattery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_id"] = this.device_id;
        data["start_date"] = this.start_date ? this.start_date.toISOString() : <any>undefined;
        data["end_date"] = this.end_date ? this.end_date.toISOString() : <any>undefined;
        data["avg"] = this.avg;
        return data;
    }
}

export interface IGetCollarBattery {
    device_id?: string | undefined;
    start_date?: moment.Moment | undefined;
    end_date?: moment.Moment | undefined;
    avg?: number;
}

export class CollarLocation extends CollarPartial implements ICollarLocation {
    pet?: PetPartial;
    owner?: CustomerPartial;
    location?: Point;
    location_updated_at?: moment.Moment | undefined;
    last_active?: moment.Moment | undefined;
    battery_charge?: number | undefined;

    constructor(data?: ICollarLocation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pet = _data["pet"] ? PetPartial.fromJS(_data["pet"]) : <any>undefined;
            this.owner = _data["owner"] ? CustomerPartial.fromJS(_data["owner"]) : <any>undefined;
            this.location = _data["location"] ? Point.fromJS(_data["location"]) : <any>undefined;
            this.location_updated_at = _data["location_updated_at"] ? moment(_data["location_updated_at"].toString()) : <any>undefined;
            this.last_active = _data["last_active"] ? moment(_data["last_active"].toString()) : <any>undefined;
            this.battery_charge = _data["battery_charge"];
        }
    }

    static override fromJS(data: any): CollarLocation {
        data = typeof data === 'object' ? data : {};
        let result = new CollarLocation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pet"] = this.pet ? this.pet.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["location_updated_at"] = this.location_updated_at ? this.location_updated_at.toISOString() : <any>undefined;
        data["last_active"] = this.last_active ? this.last_active.toISOString() : <any>undefined;
        data["battery_charge"] = this.battery_charge;
        super.toJSON(data);
        return data;
    }
}

export interface ICollarLocation extends ICollarPartial {
    pet?: PetPartial;
    owner?: CustomerPartial;
    location?: Point;
    location_updated_at?: moment.Moment | undefined;
    last_active?: moment.Moment | undefined;
    battery_charge?: number | undefined;
}

/** Получение последних известных координат ошейников, привязанных к питомцам. */
export class GetCollarLocations implements IGetCollarLocations {

    constructor(data?: IGetCollarLocations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCollarLocations {
        data = typeof data === 'object' ? data : {};
        let result = new GetCollarLocations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Получение последних известных координат ошейников, привязанных к питомцам. */
export interface IGetCollarLocations {
}

export class CollarRevision implements ICollarRevision {
    id?: string;
    description?: string;
    reviewers?: UserPartialResponse[] | undefined;

    constructor(data?: ICollarRevision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            if (Array.isArray(_data["reviewers"])) {
                this.reviewers = [] as any;
                for (let item of _data["reviewers"])
                    this.reviewers!.push(UserPartialResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CollarRevision {
        data = typeof data === 'object' ? data : {};
        let result = new CollarRevision();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        if (Array.isArray(this.reviewers)) {
            data["reviewers"] = [];
            for (let item of this.reviewers)
                data["reviewers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICollarRevision {
    id?: string;
    description?: string;
    reviewers?: UserPartialResponse[] | undefined;
}

export class GetCollarRevisions implements IGetCollarRevisions {

    constructor(data?: IGetCollarRevisions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCollarRevisions {
        data = typeof data === 'object' ? data : {};
        let result = new GetCollarRevisions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCollarRevisions {
}

export class PagedListOfCollar implements IPagedListOfCollar {
    items!: Collar[];
    meta!: PagedListMeta;

    constructor(data?: IPagedListOfCollar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.meta = new PagedListMeta();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Collar.fromJS(item));
            }
            this.meta = _data["meta"] ? PagedListMeta.fromJS(_data["meta"]) : new PagedListMeta();
        }
    }

    static fromJS(data: any): PagedListOfCollar {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfCollar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedListOfCollar {
    items: Collar[];
    meta: PagedListMeta;
}

export class Collar extends CollarPartial implements ICollar {
    serial?: string;
    firmware?: string;
    status?: DeviceStatus;
    sim_status?: SimStatus;
    ccid?: string;
    imei?: string;
    mac?: string;
    mode?: DeviceMode;
    battery?: CollarBattery | undefined;
    last_active?: moment.Moment | undefined;
    create_date?: moment.Moment;
    linked_at?: moment.Moment | undefined;
    linked_pet?: PetInfo | undefined;
    gsm_data?: boolean;
    gsm_update?: boolean;
    always_online?: boolean;
    gps_on_forever?: boolean;
    eco_mode_periods?: number;
    safe_zones_synced?: boolean;
    stride_lengths?: StrideLengths | undefined;

    constructor(data?: ICollar) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serial = _data["serial"];
            this.firmware = _data["firmware"];
            this.status = _data["status"];
            this.sim_status = _data["sim_status"];
            this.ccid = _data["ccid"];
            this.imei = _data["imei"];
            this.mac = _data["mac"];
            this.mode = _data["mode"];
            this.battery = _data["battery"] ? CollarBattery.fromJS(_data["battery"]) : <any>undefined;
            this.last_active = _data["last_active"] ? moment(_data["last_active"].toString()) : <any>undefined;
            this.create_date = _data["create_date"] ? moment(_data["create_date"].toString()) : <any>undefined;
            this.linked_at = _data["linked_at"] ? moment(_data["linked_at"].toString()) : <any>undefined;
            this.linked_pet = _data["linked_pet"] ? PetInfo.fromJS(_data["linked_pet"]) : <any>undefined;
            this.gsm_data = _data["gsm_data"];
            this.gsm_update = _data["gsm_update"];
            this.always_online = _data["always_online"];
            this.gps_on_forever = _data["gps_on_forever"];
            this.eco_mode_periods = _data["eco_mode_periods"];
            this.safe_zones_synced = _data["safe_zones_synced"];
            this.stride_lengths = _data["stride_lengths"] ? StrideLengths.fromJS(_data["stride_lengths"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Collar {
        data = typeof data === 'object' ? data : {};
        let result = new Collar();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["firmware"] = this.firmware;
        data["status"] = this.status;
        data["sim_status"] = this.sim_status;
        data["ccid"] = this.ccid;
        data["imei"] = this.imei;
        data["mac"] = this.mac;
        data["mode"] = this.mode;
        data["battery"] = this.battery ? this.battery.toJSON() : <any>undefined;
        data["last_active"] = this.last_active ? this.last_active.toISOString() : <any>undefined;
        data["create_date"] = this.create_date ? this.create_date.toISOString() : <any>undefined;
        data["linked_at"] = this.linked_at ? this.linked_at.toISOString() : <any>undefined;
        data["linked_pet"] = this.linked_pet ? this.linked_pet.toJSON() : <any>undefined;
        data["gsm_data"] = this.gsm_data;
        data["gsm_update"] = this.gsm_update;
        data["always_online"] = this.always_online;
        data["gps_on_forever"] = this.gps_on_forever;
        data["eco_mode_periods"] = this.eco_mode_periods;
        data["safe_zones_synced"] = this.safe_zones_synced;
        data["stride_lengths"] = this.stride_lengths ? this.stride_lengths.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICollar extends ICollarPartial {
    serial?: string;
    firmware?: string;
    status?: DeviceStatus;
    sim_status?: SimStatus;
    ccid?: string;
    imei?: string;
    mac?: string;
    mode?: DeviceMode;
    battery?: CollarBattery | undefined;
    last_active?: moment.Moment | undefined;
    create_date?: moment.Moment;
    linked_at?: moment.Moment | undefined;
    linked_pet?: PetInfo | undefined;
    gsm_data?: boolean;
    gsm_update?: boolean;
    always_online?: boolean;
    gps_on_forever?: boolean;
    eco_mode_periods?: number;
    safe_zones_synced?: boolean;
    stride_lengths?: StrideLengths | undefined;
}

/** Статус устройства            0 = Inactive 1 = Active 99 = Banned */
export enum DeviceStatus {
    Inactive = 0,
    Active = 1,
    Banned = 99,
}

/** 0 = Inactive 1 = Active 2 = Pending */
export enum SimStatus {
    Inactive = 0,
    Active = 1,
    Pending = 2,
}

export class CollarBattery implements ICollarBattery {
    id?: string | undefined;
    serial?: string | undefined;
    charge?: number | undefined;
    installed_at?: moment.Moment | undefined;

    constructor(data?: ICollarBattery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serial = _data["serial"];
            this.charge = _data["charge"];
            this.installed_at = _data["installed_at"] ? moment(_data["installed_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CollarBattery {
        data = typeof data === 'object' ? data : {};
        let result = new CollarBattery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serial"] = this.serial;
        data["charge"] = this.charge;
        data["installed_at"] = this.installed_at ? this.installed_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICollarBattery {
    id?: string | undefined;
    serial?: string | undefined;
    charge?: number | undefined;
    installed_at?: moment.Moment | undefined;
}

export class PetInfo implements IPetInfo {
    pet_id?: string;
    owner_id?: string;

    constructor(data?: IPetInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pet_id = _data["pet_id"];
            this.owner_id = _data["owner_id"];
        }
    }

    static fromJS(data: any): PetInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PetInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pet_id"] = this.pet_id;
        data["owner_id"] = this.owner_id;
        return data;
    }
}

export interface IPetInfo {
    pet_id?: string;
    owner_id?: string;
}

export class StrideLengths implements IStrideLengths {
    step?: number;
    run?: number;
    gallop?: number;

    constructor(data?: IStrideLengths) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.run = _data["run"];
            this.gallop = _data["gallop"];
        }
    }

    static fromJS(data: any): StrideLengths {
        data = typeof data === 'object' ? data : {};
        let result = new StrideLengths();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["run"] = this.run;
        data["gallop"] = this.gallop;
        return data;
    }
}

export interface IStrideLengths {
    step?: number;
    run?: number;
    gallop?: number;
}

export class GetCollars implements IGetCollars {
    keywords?: string | undefined;
    status?: DeviceStatus | undefined;
    page?: number;
    page_size?: number;
    sort_by?: string | undefined;
    sort_order?: SortOrder;

    constructor(data?: IGetCollars) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keywords = _data["keywords"];
            this.status = _data["status"];
            this.page = _data["page"];
            this.page_size = _data["page_size"];
            this.sort_by = _data["sort_by"];
            this.sort_order = _data["sort_order"];
        }
    }

    static fromJS(data: any): GetCollars {
        data = typeof data === 'object' ? data : {};
        let result = new GetCollars();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords;
        data["status"] = this.status;
        data["page"] = this.page;
        data["page_size"] = this.page_size;
        data["sort_by"] = this.sort_by;
        data["sort_order"] = this.sort_order;
        return data;
    }
}

export interface IGetCollars {
    keywords?: string | undefined;
    status?: DeviceStatus | undefined;
    page?: number;
    page_size?: number;
    sort_by?: string | undefined;
    sort_order?: SortOrder;
}

export class GetCustomerBatteries implements IGetCustomerBatteries {
    collar_id?: string;

    constructor(data?: IGetCustomerBatteries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.collar_id = _data["collar_id"];
        }
    }

    static fromJS(data: any): GetCustomerBatteries {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerBatteries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collar_id"] = this.collar_id;
        return data;
    }
}

export interface IGetCustomerBatteries {
    collar_id?: string;
}

export class PagedListOfFlashlight implements IPagedListOfFlashlight {
    items!: Flashlight[];
    meta!: PagedListMeta;

    constructor(data?: IPagedListOfFlashlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.meta = new PagedListMeta();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Flashlight.fromJS(item));
            }
            this.meta = _data["meta"] ? PagedListMeta.fromJS(_data["meta"]) : new PagedListMeta();
        }
    }

    static fromJS(data: any): PagedListOfFlashlight {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfFlashlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedListOfFlashlight {
    items: Flashlight[];
    meta: PagedListMeta;
}

export class Flashlight implements IFlashlight {
    mac_address?: string;
    revision?: string;
    firmware?: string;
    serial?: string;
    linked_pet?: PetInfo | undefined;
    created_at?: moment.Moment;

    constructor(data?: IFlashlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mac_address = _data["mac_address"];
            this.revision = _data["revision"];
            this.firmware = _data["firmware"];
            this.serial = _data["serial"];
            this.linked_pet = _data["linked_pet"] ? PetInfo.fromJS(_data["linked_pet"]) : <any>undefined;
            this.created_at = _data["created_at"] ? moment(_data["created_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Flashlight {
        data = typeof data === 'object' ? data : {};
        let result = new Flashlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mac_address"] = this.mac_address;
        data["revision"] = this.revision;
        data["firmware"] = this.firmware;
        data["serial"] = this.serial;
        data["linked_pet"] = this.linked_pet ? this.linked_pet.toJSON() : <any>undefined;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFlashlight {
    mac_address?: string;
    revision?: string;
    firmware?: string;
    serial?: string;
    linked_pet?: PetInfo | undefined;
    created_at?: moment.Moment;
}

export class GetFlashlights implements IGetFlashlights {
    keywords?: string | undefined;
    page?: number;
    page_size?: number;
    sort_by?: string | undefined;
    sort_order?: SortOrder;

    constructor(data?: IGetFlashlights) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keywords = _data["keywords"];
            this.page = _data["page"];
            this.page_size = _data["page_size"];
            this.sort_by = _data["sort_by"];
            this.sort_order = _data["sort_order"];
        }
    }

    static fromJS(data: any): GetFlashlights {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlashlights();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords;
        data["page"] = this.page;
        data["page_size"] = this.page_size;
        data["sort_by"] = this.sort_by;
        data["sort_order"] = this.sort_order;
        return data;
    }
}

export interface IGetFlashlights {
    keywords?: string | undefined;
    page?: number;
    page_size?: number;
    sort_by?: string | undefined;
    sort_order?: SortOrder;
}

export class Jig implements IJig {
    id?: string;
    short_id?: string;
    settings?: string;

    constructor(data?: IJig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.short_id = _data["short_id"];
            this.settings = _data["settings"];
        }
    }

    static fromJS(data: any): Jig {
        data = typeof data === 'object' ? data : {};
        let result = new Jig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["short_id"] = this.short_id;
        data["settings"] = this.settings;
        return data;
    }
}

export interface IJig {
    id?: string;
    short_id?: string;
    settings?: string;
}

export class GetJigs implements IGetJigs {

    constructor(data?: IGetJigs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJigs {
        data = typeof data === 'object' ? data : {};
        let result = new GetJigs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJigs {
}

export class GetSimInfo implements IGetSimInfo {
    collar_id?: string;

    constructor(data?: IGetSimInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.collar_id = _data["collar_id"];
        }
    }

    static fromJS(data: any): GetSimInfo {
        data = typeof data === 'object' ? data : {};
        let result = new GetSimInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collar_id"] = this.collar_id;
        return data;
    }
}

export interface IGetSimInfo {
    collar_id?: string;
}

export class FirmwareStat implements IFirmwareStat {
    revision?: string;
    versions?: FirmwareVersionStat[];
    total?: number;

    constructor(data?: IFirmwareStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revision = _data["revision"];
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(FirmwareVersionStat.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): FirmwareStat {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revision"] = this.revision;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IFirmwareStat {
    revision?: string;
    versions?: FirmwareVersionStat[];
    total?: number;
}

export class FirmwareVersionStat implements IFirmwareVersionStat {
    version?: string;
    total?: number;
    percent?: number;

    constructor(data?: IFirmwareVersionStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.total = _data["total"];
            this.percent = _data["percent"];
        }
    }

    static fromJS(data: any): FirmwareVersionStat {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareVersionStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["total"] = this.total;
        data["percent"] = this.percent;
        return data;
    }
}

export interface IFirmwareVersionStat {
    version?: string;
    total?: number;
    percent?: number;
}

export class GetFirmwareStats implements IGetFirmwareStats {

    constructor(data?: IGetFirmwareStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetFirmwareStats {
        data = typeof data === 'object' ? data : {};
        let result = new GetFirmwareStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetFirmwareStats {
}

export class PagedListOfCustomer implements IPagedListOfCustomer {
    items!: Customer[];
    meta!: PagedListMeta;

    constructor(data?: IPagedListOfCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.meta = new PagedListMeta();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Customer.fromJS(item));
            }
            this.meta = _data["meta"] ? PagedListMeta.fromJS(_data["meta"]) : new PagedListMeta();
        }
    }

    static fromJS(data: any): PagedListOfCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedListOfCustomer {
    items: Customer[];
    meta: PagedListMeta;
}

export class Customer extends CustomerPartial implements ICustomer {
    phone?: string | undefined;
    status?: UserStatus;
    time_zone?: string;
    create_date?: moment.Moment;
    update_date?: moment.Moment;
    email_confirmed?: boolean;
    total_walks?: number;

    constructor(data?: ICustomer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phone = _data["phone"];
            this.status = _data["status"];
            this.time_zone = _data["time_zone"];
            this.create_date = _data["create_date"] ? moment(_data["create_date"].toString()) : <any>undefined;
            this.update_date = _data["update_date"] ? moment(_data["update_date"].toString()) : <any>undefined;
            this.email_confirmed = _data["email_confirmed"];
            this.total_walks = _data["total_walks"];
        }
    }

    static override fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["time_zone"] = this.time_zone;
        data["create_date"] = this.create_date ? this.create_date.toISOString() : <any>undefined;
        data["update_date"] = this.update_date ? this.update_date.toISOString() : <any>undefined;
        data["email_confirmed"] = this.email_confirmed;
        data["total_walks"] = this.total_walks;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomer extends ICustomerPartial {
    phone?: string | undefined;
    status?: UserStatus;
    time_zone?: string;
    create_date?: moment.Moment;
    update_date?: moment.Moment;
    email_confirmed?: boolean;
    total_walks?: number;
}

/** 0 = NotActive 1 = Active 2 = Blocked */
export enum UserStatus {
    NotActive = 0,
    Active = 1,
    Blocked = 2,
}

/** Получение списка пользователей. */
export class GetCustomers implements IGetCustomers {
    keywords?: string | undefined;
    status?: UserStatus | undefined;
    page?: number;
    page_size?: number;
    sort_by?: string | undefined;
    sort_order?: SortOrder;

    constructor(data?: IGetCustomers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keywords = _data["keywords"];
            this.status = _data["status"];
            this.page = _data["page"];
            this.page_size = _data["page_size"];
            this.sort_by = _data["sort_by"];
            this.sort_order = _data["sort_order"];
        }
    }

    static fromJS(data: any): GetCustomers {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords;
        data["status"] = this.status;
        data["page"] = this.page;
        data["page_size"] = this.page_size;
        data["sort_by"] = this.sort_by;
        data["sort_order"] = this.sort_order;
        return data;
    }
}

/** Получение списка пользователей. */
export interface IGetCustomers {
    keywords?: string | undefined;
    status?: UserStatus | undefined;
    page?: number;
    page_size?: number;
    sort_by?: string | undefined;
    sort_order?: SortOrder;
}

export class Session implements ISession {
    os?: string;
    culture?: string;
    last_ip?: string;
    app_version?: string;
    push_token?: string;
    created_at?: moment.Moment;
    updated_at?: moment.Moment;

    constructor(data?: ISession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.os = _data["os"];
            this.culture = _data["culture"];
            this.last_ip = _data["last_ip"];
            this.app_version = _data["app_version"];
            this.push_token = _data["push_token"];
            this.created_at = _data["created_at"] ? moment(_data["created_at"].toString()) : <any>undefined;
            this.updated_at = _data["updated_at"] ? moment(_data["updated_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Session {
        data = typeof data === 'object' ? data : {};
        let result = new Session();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["os"] = this.os;
        data["culture"] = this.culture;
        data["last_ip"] = this.last_ip;
        data["app_version"] = this.app_version;
        data["push_token"] = this.push_token;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISession {
    os?: string;
    culture?: string;
    last_ip?: string;
    app_version?: string;
    push_token?: string;
    created_at?: moment.Moment;
    updated_at?: moment.Moment;
}

export class GetSessions implements IGetSessions {
    customer_id?: string;

    constructor(data?: IGetSessions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer_id = _data["customer_id"];
        }
    }

    static fromJS(data: any): GetSessions {
        data = typeof data === 'object' ? data : {};
        let result = new GetSessions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer_id"] = this.customer_id;
        return data;
    }
}

export interface IGetSessions {
    customer_id?: string;
}

export class Breed implements IBreed {
    id?: string;
    name?: string;
    localize?: { [key: string]: string; };
    height?: number;

    constructor(data?: IBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (_data["localize"]) {
                this.localize = {} as any;
                for (let key in _data["localize"]) {
                    if (_data["localize"].hasOwnProperty(key))
                        (<any>this.localize)![key] = _data["localize"][key];
                }
            }
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): Breed {
        data = typeof data === 'object' ? data : {};
        let result = new Breed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (this.localize) {
            data["localize"] = {};
            for (let key in this.localize) {
                if (this.localize.hasOwnProperty(key))
                    (<any>data["localize"])[key] = (<any>this.localize)[key];
            }
        }
        data["height"] = this.height;
        return data;
    }
}

export interface IBreed {
    id?: string;
    name?: string;
    localize?: { [key: string]: string; };
    height?: number;
}

export class GetBreeds implements IGetBreeds {

    constructor(data?: IGetBreeds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetBreeds {
        data = typeof data === 'object' ? data : {};
        let result = new GetBreeds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetBreeds {
}

export class ProfileResponse extends UserPartialResponse implements IProfileResponse {
    username?: string;
    roles?: string[];
    scopes?: string[];

    constructor(data?: IProfileResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
        }
    }

    static override fromJS(data: any): ProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProfileResponse extends IUserPartialResponse {
    username?: string;
    roles?: string[];
    scopes?: string[];
}

export class GetProfileQuery implements IGetProfileQuery {

    constructor(data?: IGetProfileQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetProfileQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfileQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetProfileQuery {
}

export class AchievementType implements IAchievementType {
    id?: string;
    header?: string;
    description?: string;
    group?: string | undefined;
    picture_url?: string;
    inactive_picture_url?: string;

    constructor(data?: IAchievementType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.header = _data["header"];
            this.description = _data["description"];
            this.group = _data["group"];
            this.picture_url = _data["picture_url"];
            this.inactive_picture_url = _data["inactive_picture_url"];
        }
    }

    static fromJS(data: any): AchievementType {
        data = typeof data === 'object' ? data : {};
        let result = new AchievementType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["header"] = this.header;
        data["description"] = this.description;
        data["group"] = this.group;
        data["picture_url"] = this.picture_url;
        data["inactive_picture_url"] = this.inactive_picture_url;
        return data;
    }
}

export interface IAchievementType {
    id?: string;
    header?: string;
    description?: string;
    group?: string | undefined;
    picture_url?: string;
    inactive_picture_url?: string;
}

export class GetAchievementTypes implements IGetAchievementTypes {

    constructor(data?: IGetAchievementTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAchievementTypes {
        data = typeof data === 'object' ? data : {};
        let result = new GetAchievementTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAchievementTypes {
}

export class ProblemDetails implements IProblemDetails {
    /** A URI reference [RFC3986] that identifies the
            problem type.  This specification encourages that, when
                dereferenced, it provide human-readable documentation for the
                problem type (e.g., using HTML [W3C.REC-html5-20141028]).  When
                this member is not present, its value is assumed to be
            "about:blank". */
    type?: string | undefined;
    /** A short, human-readable summary of the problem
            type.  It SHOULD NOT change from occurrence to occurrence of the
            problem, except for purposes of localization (e.g., using
            proactive content negotiation; see [RFC7231], Section 3.4). */
    title?: string | undefined;
    /** The HTTP status code([RFC7231], Section 6) generated by the origin server for this occurrence of the problem. */
    status?: number | undefined;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string | undefined;
    /** A URI reference that identifies the specific occurrence of the problem.It may or may not yield further information if dereferenced. */
    instance?: string | undefined;
    /** List of validation errors. */
    errors?: ValidationError[] | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ValidationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProblemDetails {
    /** A URI reference [RFC3986] that identifies the
            problem type.  This specification encourages that, when
                dereferenced, it provide human-readable documentation for the
                problem type (e.g., using HTML [W3C.REC-html5-20141028]).  When
                this member is not present, its value is assumed to be
            "about:blank". */
    type?: string | undefined;
    /** A short, human-readable summary of the problem
            type.  It SHOULD NOT change from occurrence to occurrence of the
            problem, except for purposes of localization (e.g., using
            proactive content negotiation; see [RFC7231], Section 3.4). */
    title?: string | undefined;
    /** The HTTP status code([RFC7231], Section 6) generated by the origin server for this occurrence of the problem. */
    status?: number | undefined;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string | undefined;
    /** A URI reference that identifies the specific occurrence of the problem.It may or may not yield further information if dereferenced. */
    instance?: string | undefined;
    /** List of validation errors. */
    errors?: ValidationError[] | undefined;
}

export class ValidationError implements IValidationError {
    /** Field name. */
    key?: string;
    /** Description. */
    value?: string;

    constructor(data?: IValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IValidationError {
    /** Field name. */
    key?: string;
    /** Description. */
    value?: string;
}

export class AddUserCommand implements IAddUserCommand {
    username?: string;
    nickname?: string;
    password?: string;
    roles?: string[];

    constructor(data?: IAddUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.nickname = _data["nickname"];
            this.password = _data["password"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): AddUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["nickname"] = this.nickname;
        data["password"] = this.password;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IAddUserCommand {
    username?: string;
    nickname?: string;
    password?: string;
    roles?: string[];
}

export class AddUserRoleCommand implements IAddUserRoleCommand {
    name?: string;
    scopes?: string[];

    constructor(data?: IAddUserRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
        }
    }

    static fromJS(data: any): AddUserRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        return data;
    }
}

export interface IAddUserRoleCommand {
    name?: string;
    scopes?: string[];
}

export class RemoveUserCommand implements IRemoveUserCommand {
    id?: string;

    constructor(data?: IRemoveUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RemoveUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRemoveUserCommand {
    id?: string;
}

export class RemoveUserRoleCommand implements IRemoveUserRoleCommand {
    id?: string;

    constructor(data?: IRemoveUserRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RemoveUserRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUserRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRemoveUserRoleCommand {
    id?: string;
}

export class UpdateUserCommand implements IUpdateUserCommand {
    id?: string;
    username?: string | undefined;
    nickname?: string | undefined;
    password?: string | undefined;
    roles?: string[];

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.nickname = _data["nickname"];
            this.password = _data["password"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["nickname"] = this.nickname;
        data["password"] = this.password;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserCommand {
    id?: string;
    username?: string | undefined;
    nickname?: string | undefined;
    password?: string | undefined;
    roles?: string[];
}

export class UpdateUserRoleCommand implements IUpdateUserRoleCommand {
    id?: string;
    name?: string;
    scopes?: string[];

    constructor(data?: IUpdateUserRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserRoleCommand {
    id?: string;
    name?: string;
    scopes?: string[];
}

export class RecalculateWalkCommand implements IRecalculateWalkCommand {
    id?: string;
    accuracy_percentile?: number | undefined;
    foot_kalman_decay?: number | undefined;
    car_kalman_decay?: number | undefined;
    bunch_area?: number | undefined;
    douglas_tolerance?: number | undefined;
    curve_level?: number | undefined;
    curve_strength?: number | undefined;
    ema_alpha?: number | undefined;
    ema_window?: number | undefined;

    constructor(data?: IRecalculateWalkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accuracy_percentile = _data["accuracy_percentile"];
            this.foot_kalman_decay = _data["foot_kalman_decay"];
            this.car_kalman_decay = _data["car_kalman_decay"];
            this.bunch_area = _data["bunch_area"];
            this.douglas_tolerance = _data["douglas_tolerance"];
            this.curve_level = _data["curve_level"];
            this.curve_strength = _data["curve_strength"];
            this.ema_alpha = _data["ema_alpha"];
            this.ema_window = _data["ema_window"];
        }
    }

    static fromJS(data: any): RecalculateWalkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RecalculateWalkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accuracy_percentile"] = this.accuracy_percentile;
        data["foot_kalman_decay"] = this.foot_kalman_decay;
        data["car_kalman_decay"] = this.car_kalman_decay;
        data["bunch_area"] = this.bunch_area;
        data["douglas_tolerance"] = this.douglas_tolerance;
        data["curve_level"] = this.curve_level;
        data["curve_strength"] = this.curve_strength;
        data["ema_alpha"] = this.ema_alpha;
        data["ema_window"] = this.ema_window;
        return data;
    }
}

export interface IRecalculateWalkCommand {
    id?: string;
    accuracy_percentile?: number | undefined;
    foot_kalman_decay?: number | undefined;
    car_kalman_decay?: number | undefined;
    bunch_area?: number | undefined;
    douglas_tolerance?: number | undefined;
    curve_level?: number | undefined;
    curve_strength?: number | undefined;
    ema_alpha?: number | undefined;
    ema_window?: number | undefined;
}

export class UpsertPromoCode implements IUpsertPromoCode {
    code?: string;
    trial_days?: number;
    active?: boolean;
    linked_to?: string | undefined;
    usage_limit?: number;
    note?: string | undefined;
    valid_until?: moment.Moment | undefined;

    constructor(data?: IUpsertPromoCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.trial_days = _data["trial_days"];
            this.active = _data["active"];
            this.linked_to = _data["linked_to"];
            this.usage_limit = _data["usage_limit"];
            this.note = _data["note"];
            this.valid_until = _data["valid_until"] ? moment(_data["valid_until"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpsertPromoCode {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPromoCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["trial_days"] = this.trial_days;
        data["active"] = this.active;
        data["linked_to"] = this.linked_to;
        data["usage_limit"] = this.usage_limit;
        data["note"] = this.note;
        data["valid_until"] = this.valid_until ? this.valid_until.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpsertPromoCode {
    code?: string;
    trial_days?: number;
    active?: boolean;
    linked_to?: string | undefined;
    usage_limit?: number;
    note?: string | undefined;
    valid_until?: moment.Moment | undefined;
}

export class CancelSubscriptionCommand implements ICancelSubscriptionCommand {
    pet_id?: string;

    constructor(data?: ICancelSubscriptionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pet_id = _data["pet_id"];
        }
    }

    static fromJS(data: any): CancelSubscriptionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelSubscriptionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pet_id"] = this.pet_id;
        return data;
    }
}

export interface ICancelSubscriptionCommand {
    pet_id?: string;
}

export class RefundPaymentCommand implements IRefundPaymentCommand {
    payment_id?: string;

    constructor(data?: IRefundPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payment_id = _data["payment_id"];
        }
    }

    static fromJS(data: any): RefundPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RefundPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment_id"] = this.payment_id;
        return data;
    }
}

export interface IRefundPaymentCommand {
    payment_id?: string;
}

export class UpdateSubscriptionDescriptionCommand implements IUpdateSubscriptionDescriptionCommand {
    subscription_plan_id?: string;
    lang?: string;
    name?: string;
    description?: string;
    promo_label?: string;

    constructor(data?: IUpdateSubscriptionDescriptionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscription_plan_id = _data["subscription_plan_id"];
            this.lang = _data["lang"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.promo_label = _data["promo_label"];
        }
    }

    static fromJS(data: any): UpdateSubscriptionDescriptionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubscriptionDescriptionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscription_plan_id"] = this.subscription_plan_id;
        data["lang"] = this.lang;
        data["name"] = this.name;
        data["description"] = this.description;
        data["promo_label"] = this.promo_label;
        return data;
    }
}

export interface IUpdateSubscriptionDescriptionCommand {
    subscription_plan_id?: string;
    lang?: string;
    name?: string;
    description?: string;
    promo_label?: string;
}

export class ActivateFirmware implements IActivateFirmware {
    revision?: string;
    version?: string;

    constructor(data?: IActivateFirmware) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revision = _data["revision"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ActivateFirmware {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateFirmware();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revision"] = this.revision;
        data["version"] = this.version;
        return data;
    }
}

export interface IActivateFirmware {
    revision?: string;
    version?: string;
}

export class DeactivateFirmware implements IDeactivateFirmware {
    revision?: string;
    version?: string;

    constructor(data?: IDeactivateFirmware) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revision = _data["revision"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): DeactivateFirmware {
        data = typeof data === 'object' ? data : {};
        let result = new DeactivateFirmware();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revision"] = this.revision;
        data["version"] = this.version;
        return data;
    }
}

export interface IDeactivateFirmware {
    revision?: string;
    version?: string;
}

export class ReviewFirmwareCommand implements IReviewFirmwareCommand {
    id?: string;

    constructor(data?: IReviewFirmwareCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReviewFirmwareCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewFirmwareCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IReviewFirmwareCommand {
    id?: string;
}

export class UpdateFirmware implements IUpdateFirmware {
    revision?: string;
    version?: string;
    description?: { [key: string]: string; } | undefined;
    note?: string | undefined;
    percent_for_testing?: number | undefined;

    constructor(data?: IUpdateFirmware) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revision = _data["revision"];
            this.version = _data["version"];
            if (_data["description"]) {
                this.description = {} as any;
                for (let key in _data["description"]) {
                    if (_data["description"].hasOwnProperty(key))
                        (<any>this.description)![key] = _data["description"][key];
                }
            }
            this.note = _data["note"];
            this.percent_for_testing = _data["percent_for_testing"];
        }
    }

    static fromJS(data: any): UpdateFirmware {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFirmware();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revision"] = this.revision;
        data["version"] = this.version;
        if (this.description) {
            data["description"] = {};
            for (let key in this.description) {
                if (this.description.hasOwnProperty(key))
                    (<any>data["description"])[key] = (<any>this.description)[key];
            }
        }
        data["note"] = this.note;
        data["percent_for_testing"] = this.percent_for_testing;
        return data;
    }
}

export interface IUpdateFirmware {
    revision?: string;
    version?: string;
    description?: { [key: string]: string; } | undefined;
    note?: string | undefined;
    percent_for_testing?: number | undefined;
}

export class EmailConfirmationCommand implements IEmailConfirmationCommand {
    customer_id?: string;

    constructor(data?: IEmailConfirmationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer_id = _data["customer_id"];
        }
    }

    static fromJS(data: any): EmailConfirmationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EmailConfirmationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer_id"] = this.customer_id;
        return data;
    }
}

export interface IEmailConfirmationCommand {
    customer_id?: string;
}

export class ActivateSim implements IActivateSim {
    collar_id?: string;

    constructor(data?: IActivateSim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.collar_id = _data["collar_id"];
        }
    }

    static fromJS(data: any): ActivateSim {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateSim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collar_id"] = this.collar_id;
        return data;
    }
}

export interface IActivateSim {
    collar_id?: string;
}

export class AddCollarRevision implements IAddCollarRevision {
    id?: string;
    description?: string;
    storage_size?: number;
    reviewers?: string[];

    constructor(data?: IAddCollarRevision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.storage_size = _data["storage_size"];
            if (Array.isArray(_data["reviewers"])) {
                this.reviewers = [] as any;
                for (let item of _data["reviewers"])
                    this.reviewers!.push(item);
            }
        }
    }

    static fromJS(data: any): AddCollarRevision {
        data = typeof data === 'object' ? data : {};
        let result = new AddCollarRevision();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["storage_size"] = this.storage_size;
        if (Array.isArray(this.reviewers)) {
            data["reviewers"] = [];
            for (let item of this.reviewers)
                data["reviewers"].push(item);
        }
        return data;
    }
}

export interface IAddCollarRevision {
    id?: string;
    description?: string;
    storage_size?: number;
    reviewers?: string[];
}

export class ChangeCollarServiceSettings implements IChangeCollarServiceSettings {
    collar_id?: string;
    gsm_data?: boolean | undefined;
    gsm_update?: boolean | undefined;

    constructor(data?: IChangeCollarServiceSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.collar_id = _data["collar_id"];
            this.gsm_data = _data["gsm_data"];
            this.gsm_update = _data["gsm_update"];
        }
    }

    static fromJS(data: any): ChangeCollarServiceSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeCollarServiceSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collar_id"] = this.collar_id;
        data["gsm_data"] = this.gsm_data;
        data["gsm_update"] = this.gsm_update;
        return data;
    }
}

export interface IChangeCollarServiceSettings {
    collar_id?: string;
    gsm_data?: boolean | undefined;
    gsm_update?: boolean | undefined;
}

export class DeactivateSim implements IDeactivateSim {
    collar_id?: string;

    constructor(data?: IDeactivateSim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.collar_id = _data["collar_id"];
        }
    }

    static fromJS(data: any): DeactivateSim {
        data = typeof data === 'object' ? data : {};
        let result = new DeactivateSim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collar_id"] = this.collar_id;
        return data;
    }
}

export interface IDeactivateSim {
    collar_id?: string;
}

export class UpdateCollarRevision implements IUpdateCollarRevision {
    id?: string;
    description?: string;
    reviewers?: string[];

    constructor(data?: IUpdateCollarRevision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            if (Array.isArray(_data["reviewers"])) {
                this.reviewers = [] as any;
                for (let item of _data["reviewers"])
                    this.reviewers!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateCollarRevision {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCollarRevision();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        if (Array.isArray(this.reviewers)) {
            data["reviewers"] = [];
            for (let item of this.reviewers)
                data["reviewers"].push(item);
        }
        return data;
    }
}

export interface IUpdateCollarRevision {
    id?: string;
    description?: string;
    reviewers?: string[];
}

export class UpsertJig implements IUpsertJig {
    id?: string;
    short_id?: string;
    settings?: string;

    constructor(data?: IUpsertJig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.short_id = _data["short_id"];
            this.settings = _data["settings"];
        }
    }

    static fromJS(data: any): UpsertJig {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertJig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["short_id"] = this.short_id;
        data["settings"] = this.settings;
        return data;
    }
}

export interface IUpsertJig {
    id?: string;
    short_id?: string;
    settings?: string;
}

export class AddBreed implements IAddBreed {
    en?: string;
    ru?: string | undefined;
    height?: number;

    constructor(data?: IAddBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.en = _data["en"];
            this.ru = _data["ru"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): AddBreed {
        data = typeof data === 'object' ? data : {};
        let result = new AddBreed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["en"] = this.en;
        data["ru"] = this.ru;
        data["height"] = this.height;
        return data;
    }
}

export interface IAddBreed {
    en?: string;
    ru?: string | undefined;
    height?: number;
}

export class DeleteBreed implements IDeleteBreed {
    breed_id?: string;

    constructor(data?: IDeleteBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breed_id = _data["breed_id"];
        }
    }

    static fromJS(data: any): DeleteBreed {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBreed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breed_id"] = this.breed_id;
        return data;
    }
}

export interface IDeleteBreed {
    breed_id?: string;
}

export class UpdateBreed implements IUpdateBreed {
    breed_id?: string;
    en?: string;
    ru?: string | undefined;
    height?: number;

    constructor(data?: IUpdateBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breed_id = _data["breed_id"];
            this.en = _data["en"];
            this.ru = _data["ru"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): UpdateBreed {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBreed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breed_id"] = this.breed_id;
        data["en"] = this.en;
        data["ru"] = this.ru;
        data["height"] = this.height;
        return data;
    }
}

export interface IUpdateBreed {
    breed_id?: string;
    en?: string;
    ru?: string | undefined;
    height?: number;
}

export class Impersonate implements IImpersonate {
    customer_id?: string;

    constructor(data?: IImpersonate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer_id = _data["customer_id"];
        }
    }

    static fromJS(data: any): Impersonate {
        data = typeof data === 'object' ? data : {};
        let result = new Impersonate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer_id"] = this.customer_id;
        return data;
    }
}

export interface IImpersonate {
    customer_id?: string;
}

export class SignInCommand implements ISignInCommand {
    user_name?: string;
    password?: string;
    is_persistent?: boolean;

    constructor(data?: ISignInCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_name = _data["user_name"];
            this.password = _data["password"];
            this.is_persistent = _data["is_persistent"];
        }
    }

    static fromJS(data: any): SignInCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SignInCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_name"] = this.user_name;
        data["password"] = this.password;
        data["is_persistent"] = this.is_persistent;
        return data;
    }
}

export interface ISignInCommand {
    user_name?: string;
    password?: string;
    is_persistent?: boolean;
}

export class SignOutCommand implements ISignOutCommand {

    constructor(data?: ISignOutCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SignOutCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SignOutCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISignOutCommand {
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
